import { Translation } from 'types/language/translation.lang';

export let Es: Translation = {
  charts: {
    loading: 'Cargando datos...',
    noData: 'No hay datos para mostrar',
    a11yNoValue: 'sin valor',
    toolbarExport: 'Exportar',
    toolbarExportPrint: 'Imprimir',
    toolbarExportImage: 'Exportar como {type}',
  },
  general: {
    copy: 'Copiar',
    add: 'Agregar {type}',
    empty: ' ',
    next: 'Próximo',
    back: 'Atrás',
    create: 'Crear {type}',
    start: 'Inicio',
    close: 'Cerrar',
    chartWeek: 'SEMANA {row}',
    ok: 'Ok',
    nextFish: 'Próximo pez',
    update: 'Actualizar',
    save: 'Guardar',
    edit: 'Editar {type}',
    submit: 'Enviar {type}',
    reset: 'Resetear',
    view: 'Ver',
    loading: 'Cargando...',
    delete: 'Borrar',
    deleteComment: 'Esto no se puede deshacer.',
    yesDelete: 'Si, borrar',
    ignore: 'Ignorar',
    accept: 'Aceptar',
    confirm: 'Confirmar',
    continue: 'Continuar',
    search: 'Buscar',
    notApplicable: 'No Aplica',
    hide: 'Hide',
    download: 'Descargar',
    print: 'Imprimir',
    week: 'Semana',
    day: 'Día',
    month: 'Mes',
    date: 'Fecha',
    value: 'Valor',
    degrees: 'GRADOS',
    exportScriptsBtn: 'Exportar datos',
    viewResultBtn: 'Ver resultado',
    exportPDFBtn: 'Exportar a PDF',
    exportJSONBtn: 'Exportar a JSON',
    exportCSVBtn: 'Exportar a CSV',
    confidential:
      'CONFIDENCIAL. Este documento contiene información confidencial de Cargill. Se prohíbe la divulgación, el uso o la reproducción fuera de Cargill o dentro de Cargill, para o por aquellos que no necesitan saber. Derechos de autor © Cargill, Incorporated. Todos los derechos reservados.',
    product: 'Producto',
    site: 'Centro',
    from: 'Desde',
    to: 'Hasta',
    remove: 'Eliminar',
    minimize: 'Minimizar menú',
    repeatOrder: 'Repetir el pedido',
    recalculate: 'Recalcular',
    recalculateIsNeeded: 'Es necesario volver a calcular',
    selectAll: 'Seleccionar todo',
    moreInfo: 'Más Info',
    language: 'Idioma',
    locale: 'Localización',
    company: 'Centro',
    noResults: 'Sin resultados',
    cancel: 'Cancelar',
    checkAll: 'Seleccionar todo',
    clearFilterLabel: 'Borrar los filtros',
    multiple: 'Múltiple',
    release: 'Soltar',
    clearSelection: 'Borrar selección',
    removeLine: 'Eliminar línea',
    addLine: 'Agregar línea',
    previous: 'Anterior',
    pageNotFound: {
      title: 'Página no encontrada',
      description: 'La página que buscas no existe o ha sido movida.',
      goToOverview: 'Ir a Vista General',
    },
  },
  errorBoundary: {
    retry: 'Reintentar',
    title: 'Algo salió mal',
    message: 'Esta sección no está disponible temporalmente. Inténtalo de nuevo.',
  },
  features: {
    overview: 'Vista General',
    deliveryBoard: 'Delivery Board',
    siteSettings: 'Ajustes de Sitio',
    orderFeed: 'Solicitar Alimento',
    bluViuNutrition: 'bluViu Nutrition',
    fishCheck: 'Registro de Campo',
    profilesStrategies: 'Perfiles y Estrategias',
    planningPrognosis: 'Planificación y Pronóstico',
    powerBi: 'Reporte de PowerBI',
    feedManagement: 'Administrar Alimentos',
    settings: 'Configuraciones',
    seaCloudFileUpload: 'Cargar Archivo SeaCloud',
    fileSharing: 'Archivos',
    shrimpDataUpload: 'Cargar datos camarón',

    productionSystems: 'Sistemas de Producción',
    benchmarkAnalytics: 'Benchmark Analytics',
    selfService: 'Autoservicio',

    playground: 'Playground',
  },
  login: {
    title: 'Necesita registrarse para acceder a esto',
    loginCustomer: 'Registrase como Cliente',
    loginEmployee: 'Iniciar sesión como empleado de Cargill',
  },
  selectCompany: {
    intro: 'Estás conectado a varios clientes',
    subtitle: 'Elija uno de los siguientes',
  },
  toolbar: {
    changeAccount: {
      customerNumber: 'Número',
      customerName: 'Nombre',
      signOut: 'Salir',
    },
  },
  overview: {
    dialog: {
      title: '¿Qué es bluViu?',
      readMore: 'Leer más',
      paragraphOne:
        'bluViu es la plataforma de Cargill Aqua Nutrition para brindar servicios digitales, análisis, información, optimización y transformación a las industrias acuícolas a nivel mundial.',
      paragraphTwo: 'Nuestra misión es permitir una acuicultura más sostenible y rentable para el futuro.',
      paragraphThree:
        'bluViu es 100% propiedad de Cargill, ha sido desarrollado y es administrado por un equipo exclusivamente dedicado a esta plataforma. Buscamos continuamente crear soluciones relevantes que nos conviertan en el socio preferido de los líderes de la acuicultura en todo el mundo. Integraremos flujos de datos de las cadenas de suministro y de nuestros clientes, así como de terceros tecnológicos, para brindar nuevos conocimientos, optimizaciones y oportunidades para el desarrollo de una acuicultura aún mejor. Construiremos y aprovecharemos las capacidades digitales de Cargill y de nuestros socios para beneficiar a nuestros clientes y al mundo.',
      paragraphFour:
        'Esperamos desarrollar conjuntamente este ecosistema junto con socios líderes en acuicultura. Si necesita obtener más información, comuníquese con nosotros a través de su persona de contacto en Cargill.',
      yourSites: 'Tus centros',
    },
    etaHeader: 'Pedido de ETA',
    loading: 'Cargando pedido de Eta',
    noEtaFound: 'Ningun ETA descubierto',
    onTheWay: 'ETA, esta en camino',
    notifications: 'Notificaciones',
    noNotificationsFound: 'No hay notificaciones',
  },
  deliveryBoard: {
    showFactories: 'Mostrar fábricas',
    columns: {
      loading: 'Cargando',
      onRoute: 'En ruta',
      delivered: 'Entregado',
      columns: 'Columnas',
      map: 'Mapa',
      sites: 'Sites',
      alert: {
        disclaimer:
          'El panel de entrega está en prueba beta: agradecemos sus comentarios y comprensión, ya que esta parte de la plataforma aún no está completamente desarrollada, por lo que podrían ocurrir errores y problemas.',
      },
    },
    card: {
      dispatchDate: 'Fecha de despacho:',
      editDistribution: 'Editar distribución',
      readyToDistribute: 'Listo para distribuir',
      distribute: 'Distribuir',
      edit: 'Editar',
      product: 'Producto',
      quantity: 'Cantidad',
      viewOrder: 'Ver orden',
      contactVessel: 'Contacto del buque',
      deliveryNotes: 'Notas de entrega',
      deliveryDocuments: 'Documentos de entrega',
      delayed: 'Retrasado',
      eta: 'ETA',
    },
  },
  settings: {
    name: 'Nombre',
    phone: 'Teléfono',
    email: 'Correo',
    marketContacts: 'Contactos de mercado',
    marketContactsText:
      'Si tiene alguna pregunta, póngase en contacto con la oficina de pedidos o con su persona de contacto en Cargill.',
    cargillContact: 'Persona de contacto de Cargill',
    needHelp: '¿Necesita ayuda?',
    weather: 'Tiempo',
    snowToggle: '¡Que nieve!',
    snowHint: 'Pista: También puedes escribir "navidad" en cualquier momento para activar la nieve.',
  },
  siteSettings: {
    navigation: {
      listSites: 'Centros',
      generalSettings: 'Configuración General',
      inventorySiloManagement: 'Gestión de inventarios y silos',
      contactDetails: 'Detalles de contacto',
    },
    view: {
      goToSite: 'Ir al sitio',
    },
    listSites: {
      title: 'Información General de la Compañía',
      introText: 'Configuración del centro.',
      sitesLabel: 'Sites ({value})',
      inactiveSitesLabel: 'Inactive sites ({value})',
      sitesWithoutErpIdLabel: 'Other sites ({value})',
      list: {
        noResults: 'Sin resultados',
        site: 'Centros',
        status: 'Estatus',
        siteErpIdLabel: 'Site ERP ID',
        ofdEnabledLabel: 'OFD',
        automaticOrderingLabel: 'Automatic Ordering',
        ascLabel: 'ASC',
      },
    },
    viewSiteSettings: {
      silos: 'Silos',
      totalMaxCap: 'Capacidad máxima total, kg',
      numberOfFish: 'Número de peces',
      averageWeight: 'Peso promedio, g',
    },
    editSiteSettings: {
      title: 'Configuración del centro para {name}',
      alert: 'Porfavor vuelva a calibrar el sitio.',
      emails: 'Correos electronicos',
      phoneNumbers: 'Numeros telefonicos',
      siloCapacity: {
        title: 'Configuración de Silo',
        siloSiteInventory: 'Silo Inventario del sitio',
        siloCapacityLabel: 'Capacidad de Silo',
        useFallbackData: 'Usar datos alternativos',
        siloFeedQuantityDateLabel: 'Fecha de la Cantidad de Alimento en el Silo',
        siloFeedQuantityLabel: 'Cantidad de alimento en el silo',
        dialog: {
          button: 'Editar Configuración de Silo',
          title: 'Editar Configuración de Silo',
          siloCapacityLabel: 'Capacidad de Silo Máxima',
          siloInventoryUpdatedLabel: 'Cantidad de alimentos Fecha',
          siloCurrentInventoryLabel: 'Cantidad de alimento',
        },
      },
      siloManagement: {
        title: 'Gestión del silo',
        siloName: 'Nombre del Silo',
        maxCapacity: 'Capacidad máxima',
        fleetName: 'Fleet Name',
        description: 'Description',
        capacity: 'Capacity',
        disabled: 'Disabled?',
      },
      siloFillPercentage: {
        title: 'Capacidad de llenado de silo',
        dialog: {
          warning: 'Los pedidos existentes serán modificados.',
          title: 'Editar búfer de llenado de silo',
          button: 'Editar búfer de llenado de silo',
          capacityBufferPercentage: 'Buffer de capacidad estática',
          refillSiloToLabel: 'Refill Silo To',
          setInventoryBufferLabel: 'Utilice recarga de silo estático',
          dynamicConsumptionBuffer: 'Búfer de consumo dinámico',
        },
      },
      siteComment: {
        inputLabel: 'Comentario de informacion del sitio',
        headingLabel: 'Esta informacion sera enviada al buque con cada formulario de distribucion.',
        title: 'Informacion del Sitio (destinada al buque)',
        editButton: 'Editar',
      },
      longitudeLatitude: {
        title: 'Longitud y Latitud',
        latitudeLabel: 'Latitud',
        longitudeLabel: 'Longitud',
        dialog: {
          button: 'Editar Ubicación',
          title: 'Editar Longitud y Latitud',
          latitudeLabel: 'Latitud',
          longitudeLabel: 'Longitud',
        },
      },
      temperatureProfile: {
        title: 'Perfil de Temperatura',
        selectYears: 'Seleccionar años',
        temperatureDialog: {
          title: 'Crear Perfil de Temperatura',
          subTitle: 'Temperatura promedio',
          graph: 'Graph',
          list: 'List',
        },
      },
      calibrationFeedProgram: {
        dialog: {
          title: 'Editar Programa de Alimentación',
          button: 'Editar Programa de Alimentación',
        },
      },
      calibration: {
        title: 'Calibración',
        subTitle: 'Entradas de calibración',
        isCalibrationCalculatedLabel: 'Está Calculada la Calibración',
        hasFeedProgramsLabel: 'Tiene Programas de Alimentación',
        runButton: 'Ejecutar Calibración',
        edit: 'Editar',
        save: 'Guardar',
        cancel: 'Cacelar',
        list: {
          fishSizeStartLabel: 'Tamaño Inicial de los Peces, g',
          feedIdLabel: 'Alimento',
          feedAxMgPerKgLabel: 'Eje Alimento, mg/kg',
          feedMaizeGlutenPercentLabel: 'Gluten de Maiz en el Alimento, %',
          relativeMortalityImpactLabel: 'Impacto de Mortalidad Relativa',
          relativeGrowthImpactLabel: 'Impacto de Crecimiento Relativo',
          salmonPricePremiumPerKgGuttedLabel: 'Premium del Precio del Salmón, por kilo eviscerado',
          formulationCostPerTonLabel: 'Costo de Formulación, por tonelada',
          customerPricePerTonLabel: 'Precio de Cliente, por tonelada',
        },
        dialog: {
          button: 'Editar entradas',
          name: 'Nombre',
          title: 'Editar la Calibración',
          stockingFishWeightGLabel: 'Peso de los Peces Almacenados',
          stockingDateLabel: 'Fecha de Almacenamiento',
          harvestFishWeightGLabel: 'Peso de los Peces Cosechados',
          harvestDateLabel: 'Fecha de Cosecha',
          harvestCyclebFCRLabel: 'cFCR del Ciclo de Cosecha',
          stockingFishWeightErrorLabel: 'El peso de los peces almacenados no puede ser mayor al peso de los peces cosechados.',
        },
        warningMessage: {
          caption: 'Para habilitar las entradas y poder ejecutar una calibración, asegúrese de que:',
          reasonOne: 'El centro tiene latitud y longitud configuradas',
          reasonTwo: 'El centro tiene un perfil de temperatura configurado',
          reasonThree: 'Póngase en contacto con un administrador para asegurarse de que el centro tenga las asignaciones correctas.',
        },
      },
      recommendedProducts: {
        title: 'Productos Recomendados',
        noResults: 'No se encontraron productos',
        product: {
          productName: 'Nombre de producto',
          expirationDate: 'Fecha de caducidad',
        },
        dialog: {
          title: 'Editar productos recomendados',
          button: 'Editar productos recomendados',
        },
      },
      orderFreeDelivery: {
        title: 'Pedido Entrega Gratuita',
      },
    },
  },
  orderFeed: {
    asc: 'ASC',
    navigation: {
      orderSupplyPlan: 'Mi Plan de Abastecimiento',
      orderDistribution: 'Distribución',
      orderHistory: 'Historial de Órdenes',
      createOrder: 'Crear Orden Personalizada',
      listStarvation: 'Ayuno',
      purchaseHistory: 'Compras historial',
      timeline: 'Cronología',
    },
    alert: {
      maintenance: 'La funcionalidad para ordenar se ha deshabilitado porque está en mantención',
      endsAt: 'Termina el: ',
      duplicate: 'Uno o más pedidos es una duplica',
      duplicateLine: 'Esta línea es idéntica a otra de la orden.',
      shippingSchedule: 'La fecha de envío ya no está disponible, por favor actualice la fecha de envío',
      productDateRange: 'El producto ya no existe en la lista de precios para la fecha de envío seleccionada',
    },
    ofdMySupplyPlan: {
      ordersLabel: 'Pedidos',
      inputSettingsLabel: 'Configuración',
      ofdActive: 'OFD (Order Free Delivery - Recomendación de Pedidos) activo',
      settingsUnavailableTitle: 'OFD settings are temporarily unavailable',
      settingsUnavailableMessage: 'We could not load OFD settings right now. You can retry, or continue using the rest of the page.',
      retrySettingsFetch: 'Retry',
      viewTemporarilyUnavailable: 'This section is temporarily unavailable',
      recoverView: 'Recover view',
      todayLabel: 'Hoy',
      dayOfNextDelivery: 'Día de la próxima entrega',
      tooltipContent: 'Inventario esperado durante ',
      cards: {
        startingInventory: 'Inventario inicial',
        consumptionRate: 'Tasa de consumo',
        consumption: 'Consumo',
        orderDelivered: 'Pedido entregado',
        status: 'Requiere actualización manual',
        capacity: 'de capacidad',
        day: '/ día',
        runOut: 'Se espera que el inventario se agote:',
        nextDeliveryNoDate: 'Sin fecha disponible',
        contactCustomerService: 'Contactar servicio al cliente',
        lowInventory: '¡Inventario bajo!',
        endingInventory: 'Inventario final',
        confirmedDelivery: 'Entrega confirmada:',
        forecastedDelivery: 'Entrega proyectada:',
        buttons: {
          openInventory: 'Abrir inventario',
          openConsumption: 'Abrir consumo',
        },
        drawer: {
          feedInventory: 'Inventario de alimento',
          calculateConsumption: 'Administre su tasa de consumo calculada para mantenerla precisa.',
          dailyConsumptionRate: 'Tasa de consumo diaria',
        },
        orderStatusInfo: {
          days: 'días',
          day: 'día',
          forecast: {
            forecastQuestionTitle: '¿Por qué se generó este pedido?',
            forecastAnswerContent:
              'Según su inventario actual de {stock} kg y su tasa de consumo, proyectamos una entrega de {units} kg de alimento para mantener el stock sobre el nivel de reserva.',
            forecastChangesToOrderTitle: 'Fecha de confirmación automática',
            forecastChangesToOrderContent: {
              bold: 'Le enviaremos una confirmación una vez que el pedido sea confirmado.',
              message:
                '{date} ({daysLeft} {daysLeftText} restantes - {daysBeforeDispatch} {daysBeforeText} antes del despacho) {br}{br} El pedido se ajustará automáticamente hasta entonces para mantener la precisión.',
            },
          },
          skipped: {
            skippedQuestionTitle: '¿Por qué se omitió este pedido?',
            skippedAnswerContent:
              'Según su inventario, proyectamos que no necesita recibir alimento en este despacho, ya que dispone de suficiente inventario para mantenerse por encima del stock de seguridad hasta el siguiente envío.',
          },
          open: {
            openQuestionTitle: '¿Por qué este espacio está disponible?',
            openAnswerContent:
              'No permitimos pedidos proyectados entre pedidos confirmados. {br} Sin embargo, puede crear un nuevo pedido en esta fecha de despacho disponible.',
            cannotCreateOrderQuestion: '¿Por qué el botón está deshabilitado?',
            cannotCreateOrderAnswer:
              'El sistema no generó un pedido para este envío. Ya pasó la fecha límite para la creación automática de pedidos. Comuníquese con servicio al cliente si no puede crear un pedido para este envío.',
          },
          confirmed: {
            changesTitle: 'Cambios al pedido',
            changesContent:
              'Último día para realizar cambios: {date} ({daysLeft} días restantes). {br} Después de esta fecha no será posible realizar modificaciones.',
            orderCommentTitle: 'Comentario del pedido',
          },
        },
      },
      sitesLabel: 'Centros ({value})',
      inactiveSitesLabel: 'Inactive sites ({value})',
      orders: {
        totalOrderQuantity: 'Cantidad total del pedido',
        orderQuantity: 'Cantidad del pedido',
        dispatchDate: 'Fecha de despacho',
        selectProduct: 'Seleccionar producto',
        methodOfDelivery: 'Método de entrega',
        removeOrderLine: 'Eliminar línea de pedido',
        addOrderLine: 'Agregar línea de pedido',
        customerReference: 'Número de referencia del cliente',
        orderComment: 'Comentario del pedido',
        orderDetails: 'Detalles del pedido (opcional)',
        distributionDetails: {
          title: 'Orden #{orderNumber} - Detalles de distribución',
          showTooltip: 'Mostrar detalles de distribución',
          showDistribution: 'Mostrar distribución',
          updatedAt: 'Actualizado el',
          updatedBy: 'Actualizado por',
          extraStorage: 'Almacenamiento',
          product: 'Producto',
          itemNumber: 'Número de artículo',
          quantity: 'Cantidad',
          silo: 'Silo',
        },
        availableProducts: 'Mostrar productos disponibles',
        preferredProducts: 'Mostrar productos preferidos',
        modals: {
          forecastDialog: {
            title: 'Forecasted',
            quantityMessage:
              'This quantity will continiously change and adapt to your supply until confirmed, in order to provide the most accurate forecasts.',
            overridingMessage: 'By overriding this forecast you will be taking manual control of all orders up until {date}.',
            existingForecastMessage: 'We never make forecasts between existing orders.',
            remainingForecastMessage: 'All remaining forecasted orders will automatically be adjusted to fit your changes.',
            calibrateMessage: 'We always recommend you to {calibrate} before changing an order for most accurate forecasts.',
            calibrateSettings: 'calibrate your settings',
            overrideButton: 'Override and create order',
          },
          confirmedDialog: {
            title: 'Confirmed',
            updateButton: 'Update',
            deleteButton: 'Delete order',
            skipButton: 'Skip this dispatch',
            unSkipButton: 'Confirm',
            message: 'We always recommend you to {underlined} before changing an order for most accurate forecasts.',
            underlinedMessage: 'callibrate your settings',
            deleteOrder: {
              deletionReason: 'Select the deletion reason',
              deleteOrderMessage: 'Are you sure that you want to delete this order?',
            },
            skipRecommendation: {
              skipRecommendationConfirmationMessage: 'Are you sure that you want to skip this dispatch date ({date})?',
              unSkipRecommendationMessage: 'Are you sure that you want to un-skip this dispatch date ({date})?',
              tooltipLabel:
                'Un-skip this manually skipped dispatch date. Once un-skipped, the system might come up with an order forecast for this date.',
            },
          },
          openDialog: {
            title: 'Open Slot',
          },
          skippedDialog: {
            title: 'Skipped ({type})',
          },
          viewFeedProgramsDialog: {
            viewFeedProgramsBtn: 'Ver programas de alimentación',
            noFeedStrategyAssigned: 'No hay estrategia de alimentación asignada.',
            columns: {
              fishGroup: 'Grupo de peces',
              latestWeight: 'Peso más reciente',
              feedProgram: 'Programa de alimentación',
              harvestTarget: 'Objetivo de cosecha',
            },
            options: {
              transferWeights: 'Pesos de transferencia',
              feeds: 'Alimentos',
            },
          },
        },
        filters: {
          confirmed: 'Confirmado',
          forecast: 'Proyectado',
          skipped: 'Omitido',
        },
        list: {
          delivered: 'Entregado',
          orderStatus: 'Estado del pedido',
          orderNumber: 'Número de Orden',
          customerOrderReference: 'Número de OC',
          autoConfirm: 'Confirmación automática',
          dispatchDate: 'Fecha de despacho',
          deliveryDate: 'Fecha de entrega',
          quantity: 'Cantidad',
          changes: '¿Cambios?',
          notPossible: 'No disponible',
          days: '{days} días',
          day: '{days} día',
          today: 'Hoy',
          skipped: 'Omitido ({type})',
          forecast: 'Proyectado',
          createOrderBtn: 'Crear pedido',
          createNewOrderBtn: 'Crear pedido',
          adjustSettings: 'Ajustar configuración',
          overrideForecastBtn: 'Modificar proyección',
          unskipBtn: 'Restaurar despacho',
          manual: 'Manual',
          forecasts: 'Proyecciones',
          vesselName: 'Embarcación',
          plantName: 'Planta de carga',
          orderDetails: 'Detalles del pedido',
          arrivalDate: 'Arrival date',
          arrivalTime: 'Arrival time',
          orderCreationDate: 'Order creation date',
          body: {
            product: 'Producto',
            quantityTitle:
              'Esta cantidad cambiará continuamente y se ajustará a su abastecimiento hasta que sea confirmada para proporcionar la proyección más precisa posible.',
            titleQuestion: '¿La cantidad no coincide con su planificación?',
            messageAnswer:
              'Recomendamos recalibrar su configuración antes de realizar cambios en las proyecciones OFD para mejorar la precisión.',
            productNotAvailable: 'Producto no disponible',
            productNotAvailableMessage: '- Producto no disponible.',
            productNotAvailableTooltipMessage: 'Contacte soporte al cliente para agregarlo o seleccione otro alimento.',
          },
          productsUnavailableAtPlantTitle: 'Productos no disponibles en la planta',
          productsUnavailableAtPlantMessage:
            'Los siguientes productos no se incluyen en las recomendaciones porque ninguna planta de su programa de envíos puede suministrarlos:',
          productsUnavailableAtPlantInstruction: 'Contacte a soporte al cliente para gestionar el suministro.',
          productsUnavailableAtPlantShow: 'Ver {count} productos',
          productsUnavailableAtPlantHide: 'Ocultar productos',
        },
      },
      feedInventory: {
        tooltip: {
          events: {
            delivery: 'Entrega',
            forecast: 'Proyección',
            manualUpdate: 'Actualización manual',
            consumption: 'Consumo',
            expectedConsumption: 'Consumo esperado',
          },
        },
      },
      inputSettings: {
        feedInventoryTab: {
          label: 'Feed inventory',
          headerText: 'Update your inventory every 90 days in order to receive most accurate feed forecast.',
          lastUpdated: 'Last manual update: ',
          inventoryLevelLabel: 'Enter your latest measured inventory level ',
          inventoryLevelNoDeliveryLabel: 'Enter today’s starting inventory level ',
          feedingStatusLabel: 'When was the inventory measured?',
          feedingStatusDiscloser: '(You have an expected delivery today)',
          confirmedDeliveryLabel: 'Estimated addition based on delivery: ',
          finalCalculatedLabel: 'Final calculated inventory at end of day based on input: ',
          estimatedSubtractionLabel: 'Estimated subtraction based current consumption rate:',
          estimatedSubtractionNoDeliveryLabel: 'Estimated subtraction today based current consumption rate:',
          beforeDelivery: 'Before delivery',
          afterDelivery: 'After delivery',
          daysAgo: 'days ago',
          percentage: '({percentage} of capacity)',
          dialog: {
            title: 'How was this calculated?',
            explanation:
              'Since the last inventory update, several events have impacted your current stock level. Below is a detailed log showing exactly how we arrived at the current inventory figure.',
            log: {
              title: 'Inventory log',
              day: 'Day',
              dataInput: 'Data input',
              event: 'Event',
              adjustment: 'Adjustment',
              startInventory: ' Start inventory',
              today: 'Today’s starting inventory',
              emptyArray: 'Starting inventory',
            },
          },
        },
        dailyConsumptionRateTab: {
          label: 'Daily Consumption Rate',
          headerText: 'Manage your calculated consumption rate to keep it accurate.',
          day: '/day',
          days: 'days',
          recommended: 'Historical average (Recommended)',
          manual: 'Manual adjustment (Not recommended) ',
          sealice: 'Sea lice treatment mode',
          sealiceTooltip: 'Historical average excluding starvation days due to sea lice treatment',
          calculationMethod: 'Calculation method: ',
          prognosis: 'EGI prognosis (today)',
          daysHistoricalAverage: 'Days used as historical average:',
          sliderTitle: 'Percentage offset',
          selectedCalculationLabel: 'Select calculation method',
          tooltipInfo:
            'The base forecast can be adjusted either by a percentage you set, or a percentage we calculate based on consumption average.',
          tooltipMethod:
            'Your average consumption, and our prediction model are compared, and we use the actual consumption to adjust the forecast up or down for the next 45 days.',
          tooltipPrognosis:
            'Your forecast, before adjustment, and how many days we are averaging to adjust the model. Shorter time=more responsive, longer time=more stable.',
          editRecommended: {
            historicalAverage: 'Historical average',
            sliderHeader: 'Select amount of past days to use as average for calculation (3-30 days):',
            title: 'Days',
          },
          editPrognosis: {
            prognosis: 'Manual adjustment',
            alert:
              'You have now switched from the recommended calculation. This will likely be less accurate and needs to be revisited.',
            sliderHeader: 'Adjust prognosis by setting a percentage offset:',
          },
          feedStrategyList: {
            title: 'View Feed Strategy',
            fromWeightLabel: 'From Weight',
            nameLabel: 'Product Name',
            editBtn: 'Edit Feed Strategy',
          },
        },
        feedReserveTab: {
          label: 'Feed Reserve',
          headerText:
            'In case of order delay, feed reserve will aim to keep your desired amount of feed in the inventory at all times.',
          adaptiveBufferTitel: 'Adaptive buffer',
          adaptiveBuffer: 'Adaptive',
          daysConsumption: 'days consumption',
          totalBufferText: 'Based on: Adaptive buffer + Static buffer',
          totalBufferTitel: 'Total buffer',
          adaptiveBufferText: 'Based on your current consumption, {days} days worth of feed equals {increasedDays}.',
          staticBuffer: 'Static buffer',
          staticTitleBuffer: 'Static',
          additionalBufferText: 'Adds an additional amount of feed to your feed reserve as a margin to the adaptive buffer.',
          maxCapacity: 'Max capacity: ',
          days: 'Days',
        },
        preferencesTab: {
          label: 'Preferences',
          headerText: 'Manage your general preferences for the OFD system.',
          minimumQuantityTitle: 'Minimum Forecasted Order Quantity',
          orderFrequency: 'Order Frequency',
          minimumQuantityText:
            'No orders will be placed with volume smaller than this. The site will be supplied with fewer and larger orders.',
          minimumQuantity: 'Minimum quantity',
          minimumOrderFrequencyText: 'It must be a number in the range 1-30',
          minimumOrderFrequency: 'Order Frequency',
          quantityErrorMessage: 'Quantity must be a multiple of {value}',
          minimumValueErrorMessage: '{label} must be at least {minValue}',
          rangeValueErrorMessage: 'Frequency must be between 1 and 30',
        },
      },
      timeline: {
        fortyFiveDays: '45 días',
        twentyOneDays: '21 días',
      },
    },
    listOrderSupplyPlan: {
      title: 'Mi Plan de Abastecimiento',
      filter: {
        siteLabel: 'Seleccione un centro',
        sitesLabel: 'Seleccione centros',
        fromDateLabel: 'Fecha Desde',
        toDateLabel: 'Fecha Hasta',
        options: {
          isOfdEnabled: 'OFD Habilitado',
          noSiloData: 'Dato de Silo Faltante',
          noErpAddress: 'Dirección de ERP Faltante',
        },
      },
      siteList: {
        active: 'Centros',
        inactive: 'Centros inactivos',
        noResults: 'No se encontró el centro',
        siteNameLabel: 'Centro',
        nextOrderLabel: 'Siguente orden',
        thirtyDaysPlan: 'Plan de 30 días',
        inventoryLabel: 'Inventario',
        ofdLabel: 'OFD',
        ofdEnabledTooltip: 'OFD {ofdVersion} está habilitado para este centro',
        ofdAutomaticOrderingTooltip: 'OFD {ofdVersion} y el pedido automático están habilitados para este centro',
        siteIntensityLabel: 'Intensidad del centro',
        supplyWeekLabel: 'Supply wk {weekValue}',
        weekConsumptionLabel: 'Consumo semanal',
        requireActionLabel: 'Acción requerida',
        scheduleTooShort: 'Horario demasiado corto',
        productNotAvailable: 'Producto no disponible',
        inventoryUpdateTooltip: 'Este centro puede requerir atención adicional',
      },
      orderList: {
        recommendation: 'Recomendados',
        noResults: 'No se encontraron órdenes',
        orderNumberLabel: 'Número de Orden',
        customerOrderReferenceLabel: 'Número de OC',
        requestedDeliveryDateLabel: 'Fecha centro',
        totalOrderQtyLabel: 'Cantidad Solicitada',
        productLabel: 'Producto',
        quantityLabel: 'Cantidad',
        orderedLabel: 'Solicitado',
        amountLabel: 'Cantidad',
        changePossibleLabel: 'Cambio posible?',
        noChangeableLabel: 'No',
        remainingDaysLabel: 'días restantes',
        remainingDayLabel: 'día restante',
        createOrder: {
          availableProductsGroup: 'Productos disponibles',
          preferredProductsGroup: 'Productos preferidos',
          customerReference: 'Número de OC del cliente',
          methodOfDelivery: 'Método de entrega',
          orderComment: 'Comentario del pedido',
          removeOrderLine: 'Eliminar línea de pedido',
          addOrderLine: 'Agregar línea de pedido',
          editOrderDetails: 'Editar detalles del pedido',
          productDescription: '{type}, Embalaje: {packaging}',
          orderCreated: 'Orden creada',
        },
      },
      statusList: {
        products: {
          withoutAssortmentLabel: 'Products Without Assortment',
          withoutDensityLabel: 'Products Without Density',
          correctiveActionLabel: 'Corrective Actions',
        },
        correctiveActions: {
          fixProductDensity:
            'Chequear la densidad del Producto en M3. Utilice el Servicio P&P para chequar porqué SeaCloud está recomendando los productos listados.',
          fixCustomerAssortment: 'Chequear porqué los productos listados no están en el surtido de cliente en M3.',
          fixSiloSensor: 'Contacte al cliente para resolver el problema con el sensor del silo.',
          fixSiteLinkToErp: 'Use el administrador de usuarios para asociar el centro con el centro relevante en M3.',
          specifySiteSiloInventory: 'Especifique la capacidad del silo y el inventario.',
          fixManuallySpecifiedSiloInventory: 'El inventario de silos debe actualizarse manualmente.',
          general: 'Contacte al representante del cliente para solucionar el problema identificado.',
          enableOrderFreeDelivery: 'Habilitar Entrega Sin Orden de Compra para el centro.',
        },
      },
      createOrderDialog: {
        title: 'Crear orden',
        recommendedTitle: 'Crear pedido recomendado',
        methodOfDeliveryLabel: 'Método de Entrega',
        customerOrderNumberLabel: 'Número de OC',
        orderCommentLabel: 'Comentario de Orden',
      },
    },
    orderDistribution: {
      filter: {
        fromDateLabel: 'Fecha Desde',
        toDateLabel: 'Hasta la Fecha',
      },
      infoText: 'NOTE: silo distribution closes 3 hours before boat’s arrival to site',
      distribute: 'Distribuir',
      readyForDistribution: 'Listo para distribuir',
      distributed: 'Distribuido',
      list: {
        siteName: 'Nombre del centro',
        dispatchDate: 'Fecha de despacho',
        deliveryDate: 'Fecha de entrega',
        orderQuantity: 'Cantidad de pedido',
        editDisabled: 'No es posible editar la distribución. Comuníquese directamente con el barco para realizar cambios.',
        vesselName: 'Método de entrega',
        configHasChanged: 'La configuración de esta distribución ha cambiado',
        body: {
          orderNumber: 'Número de orden',
          quantity: 'Cantidad',
          distributedQuantity: 'Cantidad Distribuida',
          productName: 'Nombre del producto',
          siloName: 'Nombre del silo',
        },
      },
      createDistribution: {
        infoText: 'NOTE: silo distribution closes 3 hours before boat’s arrival to site',
        distribute: 'Distribuir',
        capacityAlert: 'La cantidad supera la capacidad del silo',
        productAlert: 'La cantidad del producto excede la disponibilidad',
        product: 'Producto',
        quantity: 'Cantidad',
        additionalNotes: 'Notas adicionales (opcional)',
        comments: 'Informacion del sitio (Sera enviada al buque)',
        editable: 'Editable en la cofiguracion del sitio',
        overview: {
          list: {
            siteName: 'Nombre del centro',
            dispatchDate: 'Fecha de despacho',
            deliveryDate: 'Fecha de entrega',
            orderQuantity: 'Cantidad de pedido',
            body: {
              product: 'Producto',
              ordered: 'Solicitado',
              toDistribute: 'Para distribuir',
              distributed: 'Distribuido',
            },
          },
        },
        form: {
          extraStorage: 'Almacenamiento',
          pointOfContact: 'Punto de contacto',
          comments: 'Notas al buque',
          removeLine: 'Eliminar línea',
          addLine: 'Agregar línea',
          quantity: 'Cantidad',
          product: 'Producto',
          maxCapacity: 'Máxima capacidad',
          configHasChanged: 'The settings for this silo has changed',
        },
      },
    },
    orderHistory: {
      title: 'Historial de Órdenes',
      search: 'Número de Orden',
      dateRange: 'Fecha de la orden desde {fromDate} hasta {toDate}',
      ordersList: {
        noResults: 'No se encontraron órdenes, revise las fechas',
        orderNumberLabel: 'Número de Orden',
        siteName: 'Centro',
        orderDateLabel: 'Fecha de ingreso de la orden',
        deliveryDateLabel: 'Fecha centro',
        totalOrderQtyLabel: 'Cantidad',
        deliveryNotes: 'Notas de entrega',
        deliveryDocuments: 'Documentos de entrega',
        dispatchDate: 'Fecha de Despacho',
        status: 'Estado',
        orderedQuantity: 'Cantidad de Orden',
        invoicedQuantity: 'Cantidad de Factura',
        deliveredQuantity: 'Cantidad de Entrega',
        deliveryMethod: 'Método de Entrega',
        product: 'Nombre de product',
        articleNumber: 'Número de Artículo',
        lineNumber: 'Número de Línea',
      },
      filters: {
        fromDateLabel: 'Fecha Desde',
        toDateLabel: 'Fecha Hasta',
        monthView: 'Vista por mes',
        pastMonth: 'El mes pasado',
        pastThreeMonth: 'últimos tres meses',
        pastSixMonth: 'últimos seis meses',
        siteLabel: 'Seleccionar centro',
        total: 'Total',
        allSites: 'Todos los centros',
        clearSites: 'Despejar los centros',
      },
    },
    purchaseHistory: {
      title: 'Compras historial',
      chartTitle: 'Desglose por cantidad de productos',
      chartQuantity: 'Cantidad total de productos',
      groupType: 'Tipo de grupo',
      product: 'Producto',
      family: 'Familia',
      noResults: 'Sin resultados',
      monthView: 'Vista por mes',
      pastMonth: 'El mes pasado',
      pastThreeMonth: 'últimos tres meses',
      pastSixMonth: 'últimos seis meses',
      siteLabel: 'Seleccionar centro',
      total: 'Total',
      allSites: 'Todos los centros',
      clearSites: 'Despejar los centros',
    },
    viewOrder: {
      title: 'Orden #{orderNumber}',
      contactBtn: 'Contacto EWOS',
      changeableStatusClosed: 'Esta orden está cerrada y no se puede editar',
      changeableStatusOpen: 'Esta orden está abierta para ser editada hasta {date}',
      deliveryNotes: 'Notas de entrega',
      deliveryDocuments: 'Documentos de entrega',
      orderHistory: {
        updatedByLabel: 'Updated By',
        updatedAtLabel: 'Updated At',
        orderNumberLabel: 'Order Number',
        title: 'Silo distribution',
        siloNameLabel: 'Silo name',
        itemNameLabel: 'Item name',
        itemNumberLabel: 'Item number',
        quantityLabel: 'Quantity',
      },
      orderLinesList: {
        title: 'Productos solicitados',
        itemNameLabel: 'Producto',
        itemNumberLabel: 'Número de producto',
        requestedDispatchDateLabel: 'Fecha centro',
        orderQuantityLabel: 'Cantidad',
        repeatOrderBtn: 'Repetir Orden',
      },
      orderDeliveriesList: {
        itemNumberLabel: 'Producto',
        orderQuantityLabel: 'Cantidad',
      },
      orderInfo: {
        title: 'Información de la Orden',
        orderNumberLabel: 'Número de Orden',
        orderDateLabel: 'Fecha de Orden',
        requestedDeliveryDateLabel: 'Fecha centro solicitada',
        customersOrderNumberLabel: 'Número de OC',
        orderCommentsLabel: 'Comentarios',
        asc: 'ASC',
        yes: 'Yes',
      },
      invoiceInfo: {
        title: 'Información de Factura',
        customerNameLabel: 'Nombre del Cliente',
        customerNoLabel: 'Número del Cliente',
        invoiceNumberLabel: 'Número de Factura',
      },
      deliveryInfo: {
        title: 'Información de Entrega',
        transportCompanyNameLabel: 'Método de Entrega',
        deliveryDateLabel: 'Fecha centro',
        warehouseNameLabel: 'Despachado desde',
        address1Label: 'Entregar al centro',
        statusLabel: 'Estado',
        etaLabelLabel: 'ETA',
        orderStatus: {
          received: 'Recibida',
          confirmed: 'Confirmada',
          delivered: 'Entregada',
          invoiced: 'Facturada',
          canceled: 'Cancelada',
          unknown: 'Desconocido',
        },
      },
      productDeclaration: {
        title: 'Product Declaration ',
        productNumber: 'Número de producto: ',
        produced: 'Producido: ',
        bestBefore: 'Consúmase antes de: ',
        series: 'Serie: ',
        customer: 'Cliente: ',
        orderNumber: 'Número de orden: ',
        deliveredQuantity: 'Cantidad entregada: ',
        producer: 'Productor: ',
        producedBy: 'Producido por: ',
        designation: 'Designacion: ',
        instruction: 'Instrucción: ',
        analyticalComponents: 'Componentes analíticos: ',
        additives: 'Aditivos, por kg: ',
        vitamins: 'Vitaminas: ',
        micronutrients: 'Micronutrientes: ',
        pigments: 'Pigmentos: ',
        noBatches: 'No hay lotes para la línea de pedido',
        ingredients: 'Composición de las materias primas',
        asc: {
          title: 'ASC Conforming feed produced under the Mass Balance Production Model',
          info: '(www.asc-aqua.org). ASC ID number: {siteNumber}',
        },
      },
    },
    editOrder: {
      title: 'Editar Orden #{orderNumber}',
      deleteOrderBtn: 'Eliminar Orden',
      saveOrderBtn: 'Guardar Orden',
      orderLinesList: {
        removeOrderLine: 'Eliminar línea de pedido',
        addOrderLine: 'Agregar línea de pedido',
        orderDetailsLabel: 'Detalles de Orden',
        availableProducts: 'Ver productos disponibles',
        preferredProducts: 'Ver productos preferidos',
        itemNameLabel: 'Producto',
        itemNumberLabel: 'Número',
        methodOfDeliveryLabel: 'Método de Entrega',
        orderCommentLabel: 'Comentario del pedido',
        orderQuantityLabel: 'Cantidad',
        requestedDeliveryDateLabel: 'Fecha Solicitada de Despacho',
        packagingLabel: 'Empaque',
      },
      editRecommendationOrder: {
        title: 'Editar Orden',
        save: 'Guardar Orden',
        add: 'Agregar producto',
      },
    },
    listStarvation: {
      title: 'Periodos de Ayuno',
      starvingPeriodList: {
        noResults: 'Sin Resultados',
        globalSiteIdLabel: 'Centro',
        fishGroupNameLabel: 'GrupoDePeces/ Unidad',
        selectFishGroups: 'Seleccionar grupos de peces',
        startDateLabel: 'Fecha de Inicio',
        endDateLabel: 'Fecha de Término',
        comment: 'Comentario',
      },
      commentReason: {
        liceTreatment: 'Tratamiento de piojos',
        harvest: 'Cosecha',
        farmMaintenance: 'Mantenimiento de Granjas',
        fishMovement: 'Movimiento de peces',
        otherReason: 'Otra razon',
        invalid: 'Inválido',
      },
    },
    orderFeedEdit: {
      invalid: 'Seleccionar motivo',
      delousing: 'Despiojar',
      disease: 'Enfermedad',
      increasedAppetite: 'Aumento del apetito',
      reducedAppetite: 'Apetito Reducido',
      delayedDelivery: 'Entrega tardía',
      silosAreFull: 'Los silos están llenos',
      silosAreEmpty: 'Los silos están vacíos',
      scheduleChange: 'Cambio de horario',
      harvest: 'Cosechas',
      changeOfTheSupplier: 'Cambio de Proveedor',
      fleetChange: 'Cambio de Flota',
      noneOfTheAbove: 'Ninguna de las anteriores',
    },
    timeline: {
      title: 'Cronología',
      graph: {
        date: 'Fecha',
        datetime: 'Hoy',
        quantity: 'Cantidad',
        inventory: 'Inventario',
        dailyConsumption: 'Consumo diario',
        siloCapacity: 'Capacidad del silo',
        orderQuantity: 'Cantidad de pedido',
        recommendOrderQuantity: 'Cantidad de pedido recomendada',
        factoryVessel: 'Fábrica - Contenedor',
        plannedStarvation: 'Inanición planeadat',
        requestedDeliveryDate: 'Fecha de entrega requerida',
        unplannedStarvation: 'Inanición no planificada',
      },
      starvation: {
        list: {
          globalSiteIdLabel: 'Centro',
          fishGroupNameLabel: 'GrupoDePeces/ Unidad',
          selectFishGroups: 'Seleccionar grupos de peces',
          startDateLabel: 'Fecha de Inicio',
          endDateLabel: 'Fecha de Término',
        },
      },
      capacityBufferPercentage: 'Buffer de capacidad estática',
      refillSiloToLabel: 'Refill Silo To',
      setInventoryBufferLabel: 'Utilice recarga de silo estático',
      dynamicConsumptionBuffer: 'Búfer de consumo dinámico',
      siloTitle: 'Capacidad de llenado de silo',
      infoCapacityBufferPercentage:
        "Adds the given percentage of the site's silo capacity to the buffer. Recommendations will aim to keep the inventory above the buffer amount between deliveries.",
      infoDynamicConsumptionBuffer:
        'Adds the given number of days of average expected feed consumption to the silo buffer. Recommendations will aim to keep the inventory above the buffer amount between deliveries.',
      infoRefillSiloToLabel:
        "Recommendations will aim to refill the silos to the given percentage of the site's silo capacity on every delivery.",
    },
  },
  profilesStrategies: {
    generalTitle: 'General',
    ownerTitle: 'Propietario',
    linesTitle: 'Líneas',
    feedStrategy: 'Estrategia Alimentación',
    label: {
      name: 'Nombre',
      feedStrategyActive: 'La estrategia de alimentación está activa',
      feedStrategyTemporary: 'La estrategia de alimentación es temporal',
      startWeightLabel: 'Peso Inicial',
      product: 'Producto',
      period: 'Período',
      average: 'Promedio',
      profileType: 'Tipo de perfil',
      periodisation: 'periodización',
      profileSubType: 'Subtipo de perfil',
      profile: 'Perfil',
    },
    menuItem: {
      market: 'Mercado',
      company: 'Empresa',
      site: 'Centro',
      connectedFishGroups: 'Número de Grupos de Peces',
    },
    navigation: {
      listFeedStrategies: 'Estrategias Alimentación',
      listProfiles: 'Perfiles',
      editMarketProfiles: 'Perfiles de especies',
      editSiteProfiles: 'Perfiles de Centro',
    },
    listFeedStrategies: {
      title: 'Estrategias Alimentación',
      createButton: 'Crear Estrategia',
      isUserAuthorized: 'A Cargill administrator can give you access to this site',
      list: {
        noResults: 'No se ha encontrado estrategia de alimentación',
        nameLabel: 'Nombre',
        numberOfConnectedFishGroupsLabel: 'Número de Grupos de Peces',
        activeLabel: 'Activo',
        isTemporaryLabel: 'Temporal',
      },
      filters: {
        state: {
          title: 'Estado',
          active: 'Activo',
          isTemporary: 'Temporal',
        },
      },
    },
    listProfiles: {
      title: 'Perfiles',
      createButton: 'Crear Perfil',
      list: {
        noResults: 'No se ha encontrado perfiles',
        nameLabel: 'Nombre',
        activeLabel: 'Activo',

        isTemporaryLabel: 'Temporal',
        numberOfConnectedFishGroupsLabel: 'Nombre de grupo',
      },
      filters: {
        state: {
          title: 'Estado',
          active: 'Activo',
          isTemporary: 'Temporal',
        },
      },
    },
    createFeedStrategies: {
      title: 'Crear Estrategia de Alimentación',
      duplicateProfiles: 'El valor del peso inicial está duplicado',
      startWeightValue: 'El valor de peso inicial debe comenzar en cero',
    },
    editFeedStrategies: {
      title: '{name}',
      duplicateProfiles: 'El valor del peso inicial está duplicado',
      startWeightValue: 'El valor de peso inicial debe comenzar en cero',
      productInactive: 'Producto inactivo, por favor seleccione de la lista',
    },
    createProfiles: {
      title: 'Crear Perfil',
      profiles: {
        egi: 'EGI',
        efi: 'EFI',
        mort: 'Mortalidad',
      },
    },
    editProfiles: {
      title: '{name}',
      profileToggle: {
        active: 'El perfil está activo',
        temporary: 'El perfil es temporal',
        circular: 'El perfil es circular',
        input: 'El perfil es de Entrada',
      },
    },
    editMarketProfiles: {
      title: 'Editar perfiles',
      submitButton: 'Enviar perfiles',
      list: {
        noResults: 'No se ha encontrado perfiles',
        efiLabel: 'Efi',
        egiLabel: 'Egi',
        feedStrategyLabel: 'Estrategia Alimentación',
        mortalityLabel: 'Mortalidad',
        smoltTypeNameLabel: 'Tipo de Smolt',
        speciesNameLabel: 'Especies',
      },
    },
    editSiteProfiles: {
      title: 'Gestionar perfiles de Centro',
      siteLabel: 'Centro',
      selectSite: 'Seleccione un Centro',
      harvestTargetLabel: 'Objetivo de cosecha',
      weight: 'Peso',
      date: 'Fecha',
      defaultProfiles: 'Perfiles predeterminados',
      list: {
        noResults: 'No se ha encontrado perfiles',
        efiLabel: 'Efi',
        egiLabel: 'Egi',
        feedStrategyLabel: 'Estrategia Alimentación',
        mortalityLabel: 'Mortalidad',
        smoltTypeNameLabel: 'Tipo smolt',
        speciesNameLabel: 'Especies',
      },
    },
  },
  planningPrognosis: {
    navigation: {
      listSites: 'Centros',
      listNotifications: 'Notificaciones',
    },
    createVirtualFishGroup: {
      stockingDate: 'Stockingdate',
      name: 'Name',
      numberOfFish: 'Number of fish',
      stockingWeight: 'Stocking weight, g',
      species: 'Species',
      smoltType: 'Smolt type',
      strain: 'strain',
    },
    calculator: {
      egiProfile: 'EGI',
      efiProfile: 'EFI',
      mortProfile: 'Mortalidad',
      tempProfile: 'Temperatura',
      startDate: 'Fecha Inicial',
      fishGroup: 'Grupos de Peces',
      latitude: 'Latitud',
      quantity: 'Número de Peces',
      calculate: 'Calcular',
      species: 'Especies',
      meanWeight: 'Mean Weight, g',
      harvestTarget: 'Objetivo de cosecha: 5,5kg',
    },
    listSites: {
      title: 'Centros',
      list: {
        nameLabel: 'Centro',
        activeFishGroupsLabel: 'Grupos de Peces Activos',
        biomassLabel: 'Biomasa, kg',
        noResults: 'Centro No Encontrado',
        noFishLabel: 'Número de Peces',
        avgWeightLabel: 'Peso Promedio, g',
      },
      dialogMultiProfiles: {
        dialogButton: 'Editar Centros',
        title: 'Editar Centros',
      },
      dialogMultiTempProfiles: {
        dialogButton: 'Editar Perfiles Temporales',
        title: 'Editar Perfiles Temporales',
      },
    },
    viewSite: {
      title: '{siteName}',
      activitiesTitle: 'Últimas actividades de pronóstico',
      fishGroupList: {
        editMultiple: 'Editar múltiples grupos de peces',
        noResults: 'No se ha encontrado grupo de peces',
        lastFishGroupIdFromXmlLabel: 'Número',
        fishGroupNameLabel: 'Nombre',
        unitNameLabel: 'Unidad',
        smoltNameLabel: 'Smolt',
        stockingDateLabel: 'Fecha',
        stockingWeightLabel: 'Almacenamiento, g',
        currentWeightLabel: 'Actual, g',
        accEgiLabel: 'Egi',
        accEfiLabel: 'Efi',
        hasTemporaryLabel: 'Temp.',
        mortality: 'Mortalidad',
        feedStrategy: 'Estrategia Alimentación',
        createVirtualFG: 'Crear Grupos De Peces Virtuales',
      },
      forecastList: {
        noResults: 'No se ha encontrado actividad de pronóstico',
        userIdLabel: 'Usuario',
        dateLabel: 'Fecha',
        commentLabel: 'Comentario',
      },
      dialogForecast: {
        dialogButton: 'Guardar Pronóstico',
        title: 'Guardar Pronóstico',
        commentLabel: 'Comentario',
      },
      planningPrognosisTabs: {
        fishGroups: 'Grupos de peces',
        virtual: 'Virtual',
        harvest: 'Cosechado',
        changeProfiles: 'Cambiar perfiles',
        calculator: 'Calculadora',
      },
    },
    viewFishGroup: {
      title: '{unitName} - {fishGroupName}',
      snapshotsList: {
        title: 'Captura',
        noResults: 'Captura No Encontrada',
        nameLabel: 'Nombre',
        realLabel: 'Real',
        prognosisLabel: 'Prognosis',
        planLabel: 'Planificado',
        showLabel: 'Mostrar',
      },
      profileList: {
        title: 'Planificación',
        resetDefaultsBtn: 'Resetear a predeterminados del Centro',
        profileLabel: 'Perfil',
        valueLabel: 'Valor',
        levelLabel: 'Nivel',
        harvestTarget: 'Objetivo Cosecha',
        egi: 'EGI',
        efi: 'EFI',
        mortality: 'Mortalidad',
        feedStrategy: 'Estrategia Alimentación',
        temperature: 'Temperatura',
        profileLevelCountry: 'Mercado',
        profileLevelSite: 'Centro',
        profileLevelFishGroup: 'Grupo de peces',
        dialogDeleteVirtual: 'Eliminar grupo de peces virtuales',
        emptyLevel: 'Sin definir',
      },
      profilesDialog: {
        title: 'Cambiar {type} perfil',
        byWeightLabel: 'Objetivo Cosecha',
        weightBtn: 'Peso',
        dateBtn: 'Fecha',
        weightLabel: 'Peso',
        dateLabel: 'Fecha',
        egiLabel: 'Egi',
        efiLabel: 'Efi',
        mortalityLabel: 'Mortalidad',
        feedStrategyLabel: 'Estrategia Alimentación',
      },
      feedStrategyList: {
        title: 'Veer Estrategia de alimentación',
        fromWeightLabel: 'Peso Desde',
        nameLabel: 'Nombre de Producto',
        editBtn: 'Editar Estrategia de Alimentación',
      },
      temporaryPlanningList: {
        title: 'Planificación Temporal',
        noResults: 'Planificación Temporal No Encontrada',
        editTemporaryProfiles: 'Editar perfiles temporales y estrategias de alimentación',
        assignTemporary: 'Asigne perfiles temporales y estrategias de alimentación',
        profile: 'Perfil',
        type: 'Type',
        id: 'Id',
      },
    },
    listNotifications: {
      title: 'Notificaciones',
      list: {
        noResults: 'No se ha encontrado notificaciones',
        startDateLabel: 'Fecha de Inicio',
        endDateLabel: 'Fecha de Término',
        unitNameLabel: 'Jaula',
        fishGroupNameLabel: 'Grupo de peces',
        siteNameLabel: 'Centro',
        commentLabel: 'Comentario',
      },
    },
    alert: {
      title: 'Cálculo en curso',
      info: 'Se están calculando sus datos de planificación y pronóstico, espere unos minutos porfavor',
    },
    tabs: {
      activeSite: 'Centros Activos',
      harvested: 'Centros Cosechados',
      other: 'Otros Proveedores',
      active: 'Activos',
      historic: 'Histórico',
    },
    feedSummary: {
      title: 'Resumen de alimentación por Centro',
      graphDate: 'Fecha',
      graphValue: 'Valor',
      actual: 'Actual',
      planned: 'Planificado',
      delivered: 'Entregado',
      forecast: 'Pronóstico',
    },
    siteDetails: {
      title: 'Plan de alimento del sitio',
      showTableBTN: 'Mostrar tabla',
    },
  },
  bluViuNutrition: {
    title: 'Simular programas de alimentación',
    navigation: {
      listScenarios: 'bluViu Nutrition R1',
      listCalibrations: 'Calibrations',
      listBluViuNutritionR2: 'bluViu Nutrition R2',
      viewScenarioResult: 'Result',
      viewScenarioResultGt2: 'Result',
    },
    listScenarios: {
      title: 'Escenarios',
      createButton: 'Crear escenario',
      copy: 'Copiar',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      createDialog: {
        title: 'Crear Escenario',
        nameLabel: 'Nombre',
        isLandBasedFarmingLabel: 'Nombre del modelo',
      },
      cloneDialog: {
        title: 'Clonar Escenario',
        emptyModel: 'Los escenarios desactualizados no se pueden copiar',
        nameLabel: 'Nombre',
      },
      list: {
        noResults: 'Escenarios No Encontrados',
        modelLabel: 'Modelo',
        nameLabel: 'Nombre',
        updatedDateLabel: 'Actualizado',
        stateLabel: 'Estado',
      },
      filters: {
        state: {
          title: 'Estado',
        },
      },
    },
    viewScenarioResult: {
      title: 'Resultado para {name}',
      exportCSVBtn: 'Exportar a CSV',
      noScenario: 'No Scenario selected',
      tabs: {
        siteSummaryLabel: 'Resumen de Centro',
        unitSummaryLabel: 'Resumen de Unidad',
        lcaSummaryLabel: 'Resumen de LCA',
      },
      filters: {
        title: 'Mostrar Datos',
        columns: {
          permutation: 'Permutación',
          feedIntakeTons: 'Consumo alimento, T',
          productionWeeks: 'Semanas de Producción',
          stockingBiomassTons: 'Biomasa Almacenada, T',
          harvestBiomassTons: 'Biomasa Cosecha, T',
          harvestHogBiomassTons: 'Biomasa Cosecha, T',
          harvestCount: 'Cuenta Cosecha',
          salesIncomeMillions: 'Ingreso de Ventas, M',
          feedCostMillions: 'Costo Alimento, M',
          fishCostMillions: 'Costo Peces, M',
          operationsCostMillions: 'Costo de Operación, M',
          harvestCostMillions: 'Cuenta Cosecha, M',
          totalCostMillions: 'Costo Total, M',
          netProfitMillions: 'Beneficio Neto, M',
          netProfitMillionsPerYear: 'Beneficio Neto, M/Año',
          harvestHogBiomassTonsPerYear: 'Biomasa Cosecha, T/Año',
          bFcr: 'bFcr',
          eFcr: 'eFCR',
          gwpTons: 'gwp, T',
          lostNTons: 'N Perdido, T',
          feedProgram: 'Programa Alimentación',
          productionUnit: 'Unidad de Producción',
          breakPeriodWeeks: 'Periodo de Quiebre Semanas',
          harvestWeightGPerFish: 'Peso Cosecha, g/Pez',
          harvestHogWeightGPerFish: 'Peso Cosecha, g/Pez',
          feedIntakeGPerFish: 'Consumo Alimento, g/Fish',
          filletAxMgPerKg: 'Ax Filete, mg/kg',
          growthTons: 'Crecimiento, T',
          fishGroupId: 'Grupo De Peces',
        },
        lcaColumns: {
          fishGroupId: 'Fish Group Id',
          perm: 'Perm',
          prodDays: 'Prod Days',
          unitName: 'Unit Name',
          L132: 'Global warming - incl LUC, kg CO₂ eq',
          L131: 'Global warming - excl LUC, kg CO₂ eq',
          L133: 'Stratospheric ozone depletion, kg CFC11 eq',
          L134: 'Ionizing radiation, kBq Co-60 eq',
          L135: 'Ozone formation, Human health, kg NOx eq',
          L136: 'Fine particulate matter formation, kg PM2.5 eq',
          L137: 'Ozone formation, Terrestrial ecosystems, kg NOx eq',
          L138: 'Terrestrial acidification, kg SO2 eq',
          L139: 'Freshwater eutrophication, kg P eq',
          L140: 'Marine eutrophication, kg N eq',
          L141: 'Terrestrial ecotoxicity, kg 1,4-DCB',
          L142: 'Freshwater ecotoxicity, kg 1,4-DCB',
          L143: 'Marine ecotoxicity, kg 1,4-DCB',
          L144: 'Human carcinogenic toxicity, kg 1,4-DCB',
          L145: 'Human non-carcinogenic toxicity, kg 1,4-DCB',
          L146: 'Land use, m2a crop eq',
          L147: 'Mineral resource scarcity, kg Cu eq',
          L148: 'Fossil resource scarcity, kg oil eq',
          L149: 'Water consumption, m3',
          L150: 'Land Use Change (LUC), kg CO₂ eq',
          feedProgram: 'Programa de alimento',
          feedName: 'Nombre de alimento',
          endStage: 'Etapa final',
        },
      },
      label: {
        endStageSeaProductions: 'Producciones marinas de etapa final',
        endStageHog: 'End Stage Hog',
      },
    },
    viewScenarioResultGt2: {
      title: 'Summary Type',
      exportCSVBtn: 'Export results',
      referenceFeedProgram: 'Select Reference Feed Program',
      getResult: 'Get Results',
      noScenario: 'No Scenario selected',
      compareFeeds: 'Compare now',
      weeksRangeRequired: 'Please enter a week number between {minWeek} and {maxWeek}',
      weightsRangeRequired: 'Please enter weight in the range between {minWeight} g and {maxWeight} g ',
      adjustWeekLabel: 'Adjust weeks to range',
      adjustWeightLabel: 'Adjust weight to range',
      topPerformers: 'Top performers',
      lowestCo2Feed: 'has {percentage}% lower CO₂ emission per kg growth than the second best feed program',
      bestBiologyFeedWeek: 'resulted in {percentage}% higher weight gain after {week} weeks than the second best feed program',
      bestBiologyFeedWeight: 'reached the target weight {daysToReach} days quicker than the second best feed program',
      mostEconomicalFeed: ' resulted in {percentage}% lower average feed price than the second best feed program',
      selectedFeeds: 'You have {quantity} feed programs selected',
      productionRangeMessage: 'Scenario is outside of the intended scenario production range',
      clear: 'Clear',
      fixedNumber: 'less than 0.1',
      icons: {
        lowestCo2Title: 'Lowest CO₂',
        bestBioTitle: 'Fastest growth',
        mostEconomicalTitle: 'Lowest feed price',
        bestBFcrTitle: 'Best bFCR',
        lowestCostOfGrowthTitle: 'Lowest cost of growth',
      },
      compareDialog: {
        compareDialogTitle: 'Compare feed programs',
        table: 'Table',
        graph: 'Graph',
      },
      kpis: {
        selectAll: 'Select all',
        labels: {
          finalWeightGrams: 'Final Weight',
          weightGainGrams: 'Weight Gain',
          hogGainGrams: 'HOG Gain',
          daysToReach: 'Days to harvest',
          feedIntakeGrams: 'Feed intake',
          bFcr: 'bFCR',
          eFcr: 'eFCR',
          carcassYieldPercent: 'Carcass yield (%)',
          filletFatPercent: 'Fillet fat (%)',
          averageFeedCostPerKgFeed: 'Average Feed Cost',
          feedCostOfGrowth: 'Feed cost of growth',
          feedCostOfHogGain: 'Feed Cost of HOG Growth',
          feedCostTotal: 'Total feed cost',
          operationsCostTotal: 'Total operation cost',
          smoltCostTotal: 'Total smolt cost for all',
          harvestCostTotal: 'Total harvest cost',
          treatmentCostTotal: 'Total sealice cost',
          totalCost: 'Total Cost',
          potentialSalesValue: 'Potential Sales Value',
          potentialProfit: 'Potential Profit',
          globalWarmingPotentialCo2KgPerKgFeed: 'GWP CO₂/kg feed',
          globalWarmingPotentialCo2KgPerKgGrowth: 'GWP CO₂/kg growth',
        },
        tooltips: {
          finalWeightGrams: 'Average fish weight at the end of the scenario. Formula: start weight + weight gain',
          weightGainGrams: 'Average weight gain per fish. Formula: final weight - start weight',
          hogGainGrams:
            'Average HOG growth per fish, calculated as the sellable head-on-gutted share of fish weight gain. Formula: HOG growth = weight gain × carcass yield',
          daysToReach: 'Number of days from scenario start until the final weight point is reached',
          feedIntakeGrams: 'Average feed consumed per fish during the scenario period',
          bFcr: 'Biological feed conversion ratio. Feed required to produce 1 kg of weight gain. Formula: feed intake ÷ weight gain ',
          eFcr: 'Economic feed conversion ratio. Feed consumed per kg of biomass produced, including production losses ',
          carcassYieldPercent: 'Expected harvest yield at slaughter. Formula: HOG weight ÷ live weight × 100 ',
          filletFatPercent: 'Predicted fillet fat content at slaughter',
          averageFeedCostPerKgFeed:
            'Weighted average feed cost of the feed programme based on the expected feed consumption of each feed. Formula: total feed cost ÷ total feed consumed ',
          feedCostOfGrowth:
            'Weighted average feed cost required to produce 1 kg of live weight gain. Formula: total feed cost ÷ total weight gain',
          feedCostOfHogGain:
            'Weighted average feed cost required to produce 1 kg of HOG growth. Formula: total feed cost ÷ total HOG growth',
          feedCostTotal: 'Total cost of all feed consumed during the scenario',
          operationsCostTotal: 'Total operational costs based on production duration and the operational cost per week ',
          smoltCostTotal: 'Total smolt costs based on the number of stocked smolts and the smolt cost per smolt',
          harvestCostTotal: 'Total harvest costs based on harvest biomass and the harvest cost per kg',
          treatmentCostTotal: 'Total sealice treatment costs based on the number of treatments and the cost per treatment',
          totalCost:
            'Total production cost including feed cost and other production costs (treatments, fixed costs, variable costs, etc.)',
          potentialSalesValue:
            'Estimated sales value of harvested HOG biomass. Formula: total HOG biomass × relevant sales price per kg HOG ',
          potentialProfit: 'Estimated profit after production costs. Formula: Potential Sales Value - Total Production Cost',
          globalWarmingPotentialCo2KgPerKgFeed:
            'Weighted average CO₂e footprint per kg feed for the feed programme, calculated from the iLUC value of each feed and the expected feed consumption across the programme ',
          globalWarmingPotentialCo2KgPerKgGrowth:
            'Total predicted CO₂e impact per kg of fish growth from feed use. Formula: total feed consumed × feed GWP ÷ total fish growth ',
        },
      },
      tooltip: {
        weightGainGrams: 'Predicted final weight of the fish minus stocking weight',
        feedIntakeGrams: 'Predicted total feed consumption',
        filletFatPercent: 'Predicted % of fat in the fillet',
        feedCostOfGrowth:
          'Predicted final weight gain multiplied by % carcass yield. Example: 4000g weight gain x 88% carcass yield = 3520g HOG gain',
        carcassYieldPercent: 'Predicted % of fish that becomes HOG (Head-on-gutted). Fish weight – guts, visceral fat',
        finalWeightGrams: 'Model predicts the final weight of the fish',
        bFcr: 'Predicted total feed intake / weight gain',
        averageFeedCost:
          'For each feed program: The price of each feed multiplied by the amount of feed supplied, added together, and divided by the total amount of feed supplied',
        feedCostOfHogGrowth:
          'Total predicted feed cost / (weight gain x carcass yield).  Example:75kr total feed cost / 4000g weight gain x 88% carcass yield = 21.30 NOK',
        globalWarmingPotentialCo2KgPerKgGrowth: 'Total global warming potential (I_LUC) x predicted feed consumed / kg weight gain',
        hogGainGrams:
          'Predicted final weight gain multiplied by % carcass yield. Example: 4000g weight gain x 88% carcass yield = 3520g HOG gain',
        tooltipContent: 'Feed program',
        feedsInProgram: 'Feeds in program: ',
      },
      compareTable: {
        finalWeightGrams: 'Final Weight',
        daysToReach: 'Days To Reach',
        weightGainGrams: 'Weight Gain',
        feedIntakeGrams: 'Feed Intake',
        bFcr: 'bFCR',
        carcassYieldPercent: 'Carcass Yield (%)',
        filletFatPercent: 'Fillet Fat (%)',
        hogGainGrams: 'HOG Gain (g)',
        globalWarming: 'GWP CO₂/kg growth',
        averageFeedCost: 'Average Feed Cost',
        feedCostOfGrowth: 'Feed Cost Of Growth',
        feedCostOfHogGrowth: 'Feed Cost Of HOG Growth',
        reference: 'Reference',
      },
      filters: {
        types: {
          week: 'Week',
          weight: 'Weight',
        },
        visibleKpis: 'Visible KPIs',
        week: 'Week',
        weekLabel: 'Enter {minWeek} - {maxWeek} weeks',
        weight: 'Target Weight',
        weightLabel: 'Enter {minWeight} - {maxWeight} g',
      },
      columns: {
        feedPlan: 'Feed Program',
        feedPlanMaxWeeks: 'Feed Plan Max Weeks',
        feedPlanMaxWeight: 'Feed Plan Max Weight',
        finalWeightGrams: 'Final Weight(g)',
        daysToReach: 'Days To Reach',
        weightGainGrams: 'Weight Gain(g)',
        feedIntakeGrams: 'Feed Intake(g)',
        bFcr: 'bFCR',
        carcassYieldPercent: 'Carcass Yield(%)',
        filletFatPercent: 'Fillet Fat(%)',
        hogGainGrams: 'HOG Gain(g)',
        globalWarmingPotentialCo2KgPerKgGrowth: 'GWP CO₂/kg growth',
        globalWarmingPotentialCo2KgPerKgFeed: 'GWP CO₂/kg feed',
        averageFeedCost: 'Avg. Feed Cost',
        feedCostOfGrowth: 'Avg. Cost Of Growth',
        feedCostOfHogGrowth: 'Cost Of HOG Gain',
      },
      tabs: {
        compare: 'Compare',
        result: 'Results',
        graph: 'Graph',
      },
      graph: {
        yWeight: 'Weight',
        xWeek: 'Week',
        productionWeek: 'Production Week',
      },
    },
    setUp: {
      title: 'Configurar un Centro',
      viewResultsBTN: 'Ver resultado',
      submit: 'Enviar Scenario',
      save: 'Guardar',
      label: {
        name: {
          title: 'Nombre de Escenarios',
          modelName: 'Nombre del modelo',
          placeholder: 'Añadir nombre de escenario',
        },
        site: 'Seleccionar Centro',
        calibration: 'Calibration',
        description: {
          title: 'Descripción del escenario',
          placeholder: 'Añadir descripción del escenario',
        },
      },
      warningText: {
        calibration: 'El centro no está calibrado.',
        modelType: 'El centro tiene un modelo incorrecto.',
        range: 'El peso inicial debe estar entre 50 y 3000',
      },
      settingsRun: {
        title: 'Configuración del escenario',
        startDate: 'Fecha de inicio',
        endDate: 'Fecha final',
        fishWeight: 'Peso inicial',
        startDateError: 'La fecha de inicio no es anterior a la fecha final',
        endDateError: 'La fecha final no es posterior a la fecha de inicio',
      },
    },
    availableFeeds: {
      title: 'Alimentos Disponibles',
      save: 'Guardar',
      label: {
        feedProgram: 'Programa de alimentación',
        fishSize: 'Tamaño del pez',
        feed: 'Alimento',
        feedSource: 'Fuente de alimentación',
        feedAx: 'Alimentación hacha, mg/kg',
        feedMaizeGluten: 'Alimento con gluten de maíz, %',
        relativeMortalityImpact: 'Impacto relativo de la mortalidad',
        relativeGrowthImpact: 'Impacto de crecimiento relativo',
        salmonPricePremium: 'Precio del salmón de primera calidad, por kg eviscerado',
        formulationCost: 'Costo de formulación, por tonelada',
        customerPrice: 'Precio al cliente',
      },
    },
    availableFeedsEEGt2P: {
      title: 'Programas de alimentación',
      select: {
        currency: 'Moneda',
        NOK: 'NOK/100kg',
        USD: 'USD/ton',
      },
    },
    settingsRun: {
      title: 'Configuración del escenario',
      addCustomBtn: 'Agregar unidad personalizada',
      label: {
        selectProductionUnit: 'Seleccionar unidad de producción',
        currency: 'Divisa',
        unit: 'Unidad',
        fishWeight: 'Peso del pez, g',
        fishCount: 'Número de Peces ',
        statDate: 'Fecha de estado',
        fishCost: 'Costo del pez (valor por kg)',
        dailyCost: 'Costo diario (por día)',
        harvestCost: 'Costo de cosecha (por kg HOG)',
        simulationFor: 'Simulación para',
        targetWeight: 'Peso de objetivo (g)',
        productionWeeks: 'Semanas de producción',
        breakPeriod: 'Período de descanso antes de la rellenar (semanas)',
        salmonPrice: 'Precio del salmón {currency}',
        fishpoolPrice: 'Precio de piscina de peces {currency}',
        enterManually: 'Ingresar manualmente',
        selectionCriteria: 'Criteria de selección',
        feedConversionBiological: 'Conversión de alimentos biológicos',
        feedCostPerSite: 'Costo de alimentación/Centro',
        harvestHogPerSitePerYear: 'Cosecha HOG/Centro/Año',
        netProfitPerSite: 'Red Beneficio/Centro',
        netProfitPerSitePerYear: 'Red Beneficio/Centro por año',
        productionTime: 'Tiempo de producción',
        salesIncomePerSite: 'Ingresos por ventas/Centro',
        totalCostPerSite: 'Costo total/Centro',
        setRegulatoryFramework: 'Establecer marco regulatorio',
        noLimits: 'Sin limites',
        maximumAllowedBiomass: 'Máximo permitido de biomasa',
        harvestMethod: 'Método de cosecha',
        batchHarvest: 'Cosecha por lotes',
        allowedBiomass: 'Límite de biomasa permitido (toneladas)',
      },
    },
    calibrations: {
      listCalibrations: {
        stateTooltip: {
          modified:
            'The inputs of this calibration have been modified since last calibrated. Coefficients will likely change if you run calibration again.',
        },
        list: {
          name: 'Name',
          model: 'Model',
          calibratedAt: 'Calibrated at',
          growth: 'Growth',
          feedIntake: 'Feed intake',
          state: 'State',
        },
      },
      createCalibration: {
        create: 'Create calibration',
      },
      cloneCalibration: {},

      editCalibration: {
        calibrationInProgress: {
          title: 'Calibration in progress',
          text: 'You are free to leave this page while the calibration is running. This may take a few minutes depending on the complexity of your site data.',
        },
        calibrationStatistics: {
          status: {
            title: 'Status',
            modifiedTooltip:
              'The inputs of this calibration have been modified since last calibrated. Coefficients will likely change if you run calibration again.',
          },
          weightGain: {
            title: 'Weight gain',
          },
          feedIntake: {
            title: 'Feed intake',
          },
        },
        calibrationActions: {
          exportScript: 'Export Script',
          exportCSV: 'Export CSV',
          clone: 'Clone',
        },
        calibrationInformation: {
          title: 'Calibration',
          form: {
            name: 'Calibration name',
            model: 'Calibration model',
            description: 'Calibration description',
          },
        },
        temperatureLocation: {
          temperatureProfile: {
            title: 'View Temperature Profile',
            dialogButton: 'View Temperature Profile',
            buttonGroup: {
              graph: 'Graph',
              list: 'List',
            },
            header: 'Average Temperature',
            chart: {
              week: 'Week',
              degrees: 'Degrees',
            },
            table: {
              week: 'Week',
              temperature: 'Temperature',
            },
            information: 'To edit your temperature profile, go to site settings.',
          },
          location: {
            title: 'Longitude and latitude',
            dialogButton: 'View Location',
            latitude: 'Latitude',
            longitude: 'Longitude',
            information: 'To edit your location, go to site settings.',
          },
          information: 'No temperature profile available, create one in site settings.',
        },
        inputs: {
          title: 'Inputs',
          single: {
            form: {
              stockingDate: 'Stocking date',
              stockingFishWeight: 'Stocking fish weight',
              harvestDate: 'Harvest date',
              harvestFishWeight: 'Harvest fish weight',
              harvestCyclebFcr: 'Harvest Cycle bFCR',
            },
          },
          multi: {
            selectYear: 'Select year',
            information: 'Select year that you want to use as inputs for calibration.',
            cages: {
              information: 'Select cages that you want to use as inputs for calibration.',
              list: {
                fishGroup: 'Fish group',
                cageTooltip: 'Cage: {unitName}',
                stockingDate: 'Stocking date',
                startWeight: 'Start weight',
                bFCR: 'bFCR',
                harvestDate: 'Harvest date',
                avgHarvestMW: 'Avg. Harvest MW',
                egi: 'EGI',
              },
            },
          },
        },
        feedProgram: {
          title: 'Feed program',
          columns: {
            feed: 'Feed',
            quantity: 'Fish start size (g)',
          },
        },
        runCalibration: {
          information: 'Running the calibration may take a while depending on the complexity of your site data.',
          button: 'Run calibration',
        },
      },
    },
    applyFeed: {
      title: 'Aplicar programas de alimentación',
      stepIndicator: 'Paso {step} de {total} - {stepLabel}',
      buttonLabel: 'Aplicar programas de alimentación',
      confirmAndApply: 'Confirmar y aplicar',
      missingMapping: 'Algunos productos aún no han sido mapeados',
      applyAs: {
        label: 'Aplicar como:',
        plan: {
          title: 'Plan',
          description: 'El plan actual que seguirá el sitio.',
        },
        forecast: {
          title: 'Proyección',
          description: 'Un escenario "Qué pasaría si" para usar durante el ciclo de producción.',
        },
        planAndForecast: {
          title: 'Plan y Proyección',
          description: 'Aplica el escenario como plan y proyección.',
        },
      },
      reviewList: {
        title: 'Revisar programas de alimentación antes de aplicarlos a su sitio:',
        fishGroup: 'Grupo de peces',
        newFeedProgram: 'Nuevo programa de alimentación',
      },
      excludedFishGroups: {
        title: 'Grupos de peces excluidos',
      },
      mapping: {
        infoBox:
          'Los productos en bluViu Nutrition no son los mismos que en SAP. Mapee los productos en los programas de alimentación para que bluViu Nutrition y OFD puedan conectarse.',
        weight: 'Peso',
        feedsInBluViuNutrition: 'Alimentos en bluViu Nutrition',
        feedsInSAP: 'Alimentos en SAP',
        product: 'Producto *',
        mappedLabel: 'mapeado',
      },
    },
  },
  bluViuNutritionR2: {
    scenarioValidation: {
      invalidFishGroupData: 'One or more fish groups contain invalid data.',
      reviewFishGroupData: 'Please review the imported fish-group data.',
      reviewScenarioEndDate: 'Please review the Scenario end date in the Production Inputs section below.',
    },
    results: {
      graph: {
        allAvgForSite: 'All (Avg. for site)',
        allPrograms: 'All Programs',
        potentialSalesValue: 'Potential Sales Value',
        potentialSalesValueDisabled: 'Select one feed program to view potential sales value.',
        showFeedProgram: 'Show feed program',
        showResultsFor: 'Show results for',
        valueBySizeClass: 'Total value by size class',
        valueBySizeClassDisabled: 'Select one feed program to view value by size class.',
        weeks: 'Weeks',
        weight: 'Weight (g)',
      },
    },
  },
  fishCheck: {
    navigation: {
      listWelfareScoring: 'Puntaje de Bienestar',
      dialog: {
        deleteTitle: 'Borrar Muestra',
        title: 'Inicio',
        nameLabel: 'Ingrese Nombre',
        templateAndSiteLabel: 'Seleccionar centro y modelo',
        templateLabel: 'Modelo',
        siteLabel: 'Seleccionar Centro',
      },
    },
    header: {
      siteNameLabel: 'Centro',
      dateCreatedLabel: 'Creado',
      dateLastUpdatedLabel: 'Fecha Actualizada',
      activeLabel: 'Activo',
      commentLabel: 'Comentario',
      addNewFishLabel: 'Agregar nuevo Pez',
    },
    listWelfareScoring: {
      title: 'Reporte de Puntaje de Bienestar',
      list: {
        noResults: 'Sin Resultados',
        nameLabel: 'Nombre',
        siteNameLabel: 'Centro',
        dateCreatedLabel: 'Creado',
        activeLabel: 'Activo',
      },
    },
    editWelfareScoring: {
      title: 'Editar {name}',
      editTitle: 'Editar muestra',
      updateSample: 'Actualizar muestra',
      alert: 'Uno o varios campos deben tener un valor',
      fishGroupIdLabel: 'Seleccionar Unidad de Producto',
      dateCreatedLabel: 'Seleccionar Dieta',
      fishWelfareData: {
        cageLabel: 'Jaula',
        fishGroupLabel: 'Grupo De Peces',
        adultFemaleLice: 'Piojo Hembra Adulta',
        kFactor: 'Factor-K',
        skinBleeding: 'Sangramiento de Piel',
        wounds: 'Heridas',
        length: 'Largo (cm)',
        weight: 'Peso (g)',
        stationaryLice: 'Stationary Lice',
        mobileLice: 'Mobile Lice',
        scottishLice: 'Scottish Lice',
        backboneDeformity: 'Backbone Deformity',
        thinness: 'Thinness',
        maturation: 'Maturation',
        scaleLoss: 'Scale Loss',
        snoutWounds: 'Snout Wounds',
        jawDeformity: 'Jaw Deformity',
        paleEye: 'Pale Eye',
        eyeDamage: 'Eye Damage',
        gillCover: 'Gill Cover',
        gillStatus: 'Gill Status',
        finStatus: 'Fin Status',
        firstImpression: 'First Impression',
        comment: 'Comment',
      },
    },
  },
  feedManagement: {
    navigation: {
      listPlants: 'Plantas',
      listNutrients: 'Nutrición',
      listBestMixFeeds: 'BestMix Feeds',
      listManualFeeds: 'Manual Feeds',
      listCustomers: 'Clientes',
    },
    listPlants: {
      title: 'Plantas',
      button: 'Crear plantas',
      list: {
        noResults: 'Usted no tiene plantas',
        codeLabel: 'Código',
        nameLabel: 'Nombre',
        marketsLabel: 'Mercados',
      },
      dialog: {
        title: 'Crear nueva Planta',
        codeLabel: 'Código',
        marketsLabel: 'Mercados',
        nameLabel: 'Nombre',
      },
      tooltip: {
        product: 'Products does not have base nutrient values to support nutrient calculation',
        incorrectValues: 'BestMix nutrients have incorrect values',
      },
    },
    listNutrients: {
      title: 'Selección de Nutrición',
      digestibleFatGPerKgLabel: 'Grasa Digestible',
      feedGwpKgCo2EqPerKgLabel: 'GWP del Alimento',
      idealProteinNitrogenLabel: 'Nitrógeno proteico ideal',
      nonIdealProteinNitrogenLabel: 'Nitrógeno proteico no ideal',
    },
    editPlant: {
      title: '{code} {name}',
      list: {
        title: 'Mercados Asociados',
        noResults: 'Sin Resultados',
        nameLabel: 'Mercados',
        actionLabel: 'Remover',
      },
      selectMarketLabel: 'Seleccione Mercado',
    },
    listBestMixFeeds: {
      title: 'Productos',
      deactivateFeeds: 'Desactivar Alimentos',
      activateFeeds: 'Activar Alimentos',
      selectAllFeeds: 'Seleccionar todos los alimentos en la página actual',
      linkToCustomer: 'Asignar clientes',
      list: {
        noResults: 'Sin Resultados',
        nameLabel: 'Nombre',
        numberLabel: 'Código / Nombre',
        updatedDateLabel: 'Fecha Actualizada',
        activeLabel: 'Mostrar Activos',
        inactiveLabel: 'Mostrar Inactivos',
      },
      filter: {
        plantLabel: 'Planta',
        statusLabel: 'Estado de BestMix',
        options: {
          active: 'Activo',
          temporary: 'Temporario',
          hasMandatoryNutrients: 'Inválido',
        },
      },
      dialog: {
        deactivate: 'Desactivar',
        activate: 'Activar',
        activateTitle: 'Activar Alimentos',
        deactivateTitle: 'Desactivar Alimentos',
        activateDialog: '¿Está seguro de que desea activar los alimentos seleccionados?',
        deactivateDialog: '¿Está seguro de que desea desactivar los alimentos seleccionados?',
        linkToSelectedCustomers: 'Asignar productos seleccionados?',
        customerSelect: 'Clientes',
      },
      tooltip: {
        product: 'El producto no tiene valores de nutrientes básicos para soportar el cálculo de nutrientes.',
        incorrectValues: 'Los nutrientes BestMix tienen valores incorrectos',
      },
    },
    editBestMixFeed: {
      title: '{code} {name}',
      bestMixFeedDetails: {
        title: 'Detalles del Producto',
        descriptionLabel: 'Descripción',
        plantCodeLabel: 'Código de Planta',
        codeLabel: 'Código',
        bestMixFeedNumberLabel: 'Número',
        formulationCostLabel: 'Costo de Formulación',
        bestMixFeedVersionLabel: 'Versión',
      },
      assignedCompaniesList: {
        title: 'Clientes Asociados',
        noResults: 'Sin Resultados',
        nameLabel: 'Nombre',
        priceLabel: 'Precio de Cliente',
      },
      assignedCompaniesDialog: {
        openBtn: 'Asociación Cliente',
        title: 'Asociación Cliente',
        customerLabel: 'Cliente',
        customerPricePerToneLabel: 'Precio Cliente / Ton',
      },
      customFieldsList: {
        title: 'Campos Personalizados',
        noResults: 'Sin Resultados',
        nameLabel: 'Nombre',
        valueLabel: 'Valor',
      },
      customFieldsDialog: {
        openBtn: '{action} Campo Personalizado',
        title: '{action} Campo Personalizado',
        customFieldsLabel: 'Campos Personalizados',
        customFieldValueLabel: 'Valor',
      },
      nutrientsMaterialsList: {
        nutrientsTitle: 'Nutrición',
        materialsTitle: 'Materiales',
        noResults: 'Sin Resultados',
        codeLabel: 'Código',
        nameLabel: 'Nombre',
        valueLabel: 'Valor',
      },
    },
    listCustomers: {
      title: 'Clientes',
      list: {
        noResults: 'No hay clientes',
        nameLabel: 'Nombre de Cliente',
      },
    },
    editCustomer: {
      title: '{name}',
      unlinkBtn: 'Desconectar',
      disconnectBtn: 'Desconectar alimentos',
      selectAllFeeds: 'Seleccionar todos los alimentos en la página actual',
      linkProductDialog: {
        openBtn: 'Enlazar nuevo alimento BestMix',
        title: 'Enlazar alimento BestMix',
        productsLabel: 'Alimentos Bestmix',
        customerPricePerToneLabel: 'Precio de Cliente / Ton',
      },
      disconnectDialog: {
        title: 'Disconnect feeds',
        disconnectLabel: 'Disconnect selected feeds?',
        disconnectBtn: 'Disconnect',
      },
      list: {
        title: 'Alimentos Bestmix enlazados',
        noResults: 'No hay alimentos BestMix enlazados',
        descriptionLabel: 'Alimentos Bestmix enlazados',
        customerPricePerTonLabel: 'Precio de Cliente por Ton',
        hasMandatoryNutrientsLabel: 'Nutrientes faltantes',
        hasIncorrectBestMixNutrientValuesLabel: 'Valores de nuetrientes incorrectos',
        updatedDateLabel: 'Actualizar fecha',
      },
    },
    listManualFeeds: {
      title: 'Alimentos manuales',
      deactivateFeeds: 'Desactivar Alimentos',
      activateFeeds: 'Activar Alimentos',
      selectAllFeeds: 'Seleccionar todos los alimentos en la página actual',
      linkToCustomer: 'Asignar clientes',
      createFeed: 'Nuevo alimento',
      dialog: {
        title: 'Crear alimento manual',
        nameLabel: 'Nombre',
        pelletSizeLabel: 'Tamaño de Pellet',
        deactivate: 'Desactivar',
        activate: 'Activar',
        activateTitle: 'Activar Alimentos',
        deactivateTitle: 'Desactivar Alimentos',
        activateDialog: '¿Está seguro de que desea activar los alimentos seleccionados?',
        deactivateDialog: '¿Está seguro de que desea desactivar los alimentos seleccionados?',
        linkToSelectedCustomers: 'Asignar productos seleccionados?',
        customerSelect: 'Clientes',
      },
      list: {
        noResults: 'No se ha encontrado alimentos',
        nameLabel: 'Nombre',
        createdDateLabel: 'Fecha creada',
        updatedDateLabel: 'Fecha de Actualización',
        activeLabel: 'Activo',
        inactiveLabel: 'Inactivo',
        feedFilterLabel: 'Filtros',
        feedFilterOptions: {
          all: 'Todos',
          currentCompany: 'Compañía actual',
          me: 'Yo',
          currentCompanyAndMe: 'Compañía actual y yo',
        },
      },
    },
    editManualFeed: {
      title: 'Editar un alimento manual',
      nameLabel: 'Nombre',
      activeLabel: 'Activo',
      inactiveLabel: 'Inactivo',
      list: {
        essentialNLabel: 'N Esencial',
        effectiveEnergyLabel: 'Energía Efectiva',
        nonEssentialNLabel: 'N No Esencial',
        crudeProteinLabel: 'Proteína Cruda',
        feedGwpLabel: 'GWP Alimento',
        digestibleFatLabel: 'Grasa Digestible',
        idealProteinNitrogenLabel: 'Ideal Protein Nitrogen',
        nonIdealProteinNitrogenLabel: 'Non-ideal Protein Nitrogen',
        scalingFactorFeedIntake: 'Scaling Factor Feed Intake',
        scalingFactorWeightGain: 'Scaling Factor Weight Gain',
      },
      customers: 'Clientes',
      users: 'Usuarios',
      calculateNutrients: {
        title: 'Calculate nutrients',
        calculate: 'Calculate',
        list: {
          arginine: 'Digestible Arginine salmonids',
          histidine: 'Digestible Histidine salmonids',
          isoleucine: 'Digestible Isoleucine salmonids',
          leucine: 'Digestible Leucine salmonids',
          lysine: 'Digestible Lysine salmonids',
          methionine: 'Digestible Methionine salmonids',
          phenylalanineTyrosine: 'Digestible Phenylalanine + Tyrosine salmonids',
          threonine: 'Digestible Threonine salmonids',
          tryptophan: 'Digestible Tryptophan salmonids',
          valine: 'Digestible Valine salmonids',
          methionineCysteine: 'Digestible Methionine + Cysteine salmonids',
          protein: 'Digestible Protein salmonids',
        },
      },
    },
  },
  powerBi: {
    navigation: {
      listReports: 'Reportes',
    },
    listReports: {
      title: 'Reportes',
      list: {
        noResults: 'Sin Resultados',
        nameLabel: 'Nombre',
      },
    },
    viewReport: {
      utils: {
        downloadBtn: 'Descargar PDF',
        exportBtn: 'Exportar PDF',
        fullscreenBtn: 'Pantalla completa',
      },
      error: {
        message: 'El informe al que intenta acceder no se encuentra en este momento',
        title: 'Reportes',
      },
    },
  },
  fileSharing: {
    title: 'Compartir archivos',
    currentFolder: 'Carpeta actual',
    subFolders: 'Subcarpetas',
    files: 'Archivos',
    selectFromList: 'Seleccione un archivo de la lista',
    list: {
      name: 'Nombre',
      dateCreated: 'Creado',
      folderName: 'Nombre de carpeta',
      noSubFolders: 'No se encontraron subcarpetas',
    },
  },
  seaCloudFileUpload: {
    cancelButton: 'Cancel and discard file',
    navigation: {
      viewFileSummary: 'Cargar Archivo',
    },
    viewFileSummary: {
      title: 'Enviar datos del centro a SeaCloud',
    },
  },
  shrimpDataUpload: {
    navigation: {
      viewShrimpDataUpload: 'Cargar Archivo',
    },
    fileTypeError: 'Tipo de archivo incompatible. Por favor, subir un archivo Excel (.xlsx o .xls).',
    uploadSuccess:
      '¡Archivo cargado con éxito! Procesar el archivo puede tomar algún tiempo, recibirá reporte detallado por correo electrónico cuando haya sido procesado.',
    uploadButton: 'Cargar archivo',
    chooseProductionFile: 'Seleccione un archivo de data PRODUCTIVA para cargar',
    chooseSanitationFile: 'Seleccione un archivo de data SANITARIA para cargar',
    chooseFile: 'Seleccionar archivo',
  },
  productionSystems: {
    lockPondContainer: {
      partialLock: {
        bold: 'Algunos estanques están actualmente bloqueados por otro usuario.',
        message: 'Estos estanques no se incluirán en su sesión de registro.',
      },
      fullLock: {
        bold: 'Los estanques seleccionados están actualmente bloqueados por otro usuario.',
        message: 'Seleccione otros estanques o continuar en modo de solo lectura.',
      },
      notGrantedLabel: 'Estanques bloqueados por otros usuarios (no se incluirán)',
      grantedLabel: 'Estanque(s) de destino',
    },
    listSelectedPonds: {
      registrationDate: 'Fecha de registro',
      selectedPonds: 'Estanques seleccionados',
      list: {
        name: 'Estanque',
        zone: 'Granja',
        status: 'Estado',
        activeDays: 'Días activos',
      },
    },
    pondName: 'Nombre de estanque',
    selectFarm: 'Seleccionar zona',
    timer: {
      reset: 'Restablecer sesión',
      expire: 'Esta sesión expirará en {time}',
      error: 'Tu session ha expirado por inactividad. Tu trabajo no ha sido guardado',
    },
    summary: 'Resumen',
    selectedFarm: 'Granja seleccionada: ',
    selectedDate: 'Fecha de registro seleccionada',
    farmOverview: {
      title: 'Resumen de la granja',
      farms: {
        name: 'Zona',
        numberOfPonds: 'No. de estanques',
        lastRegistrationDate: 'Última fecha de registro',
      },
      duplicateRegistration: 'Este evento ya fue realizado en {date} para: {ponds}. Por favor revisarlo para evitar ingresar duplicados.',
      list: {
        name: 'Estanque',
        zone: 'Granja',
        active: 'Activo',
        days: 'No. Dias',
        noShrimps: 'No. Camarones',
        biomass: 'Biomasa ({type})',
        meanWeight: 'Peso medio (g)',
      },
      buttons: {
        newStock: 'Sembrar',
        newTransfer: 'Transferir',
        newHarvest: 'Cosechar',
        newFeeding: 'Agregar nueva alimentación',
        sampling: 'Muestra de  peso medio',
        waterQuality: 'Calidad del agua',
        newTreatment: 'Agregar un nuevo tratamiento',
        previousDay: 'Día anterior',
        nextDay: 'Día próximo',
      },
      filters: {
        showActive: 'Mostrar estanques activos',
        showInactive: 'Mostrar estanques inactivos',
        registrationDate: 'Fecha de registro',
        zone: 'Filtro por granja',
        selectAll: 'Seleccionar todo',
        pondType: 'Tipo de estanque',
        poundsOrKg: 'Libras (lbs) / kg',
        pondTypes: {
          Production: 'Producción',
          Raceway: 'Raceway',
          Nursery: 'Precria',
        },
      },
      feeding: {
        add: {
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          zone: 'Granja',
          number: 'Número actual',
          meanWeight: 'Peso medio actual (g)',
          biomass: 'Biomasa actual ({type})',
          feed: 'Alimento',
          feederBrand: 'Seleccionar alimentador',
          feedQuantity: 'Cantidad de alimento ({type})',
          summary: 'Resumen',
          switchLabel: 'Libras (lbs) / Kg',
        },
        edit: {
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          zone: 'Granja',
          number: 'No. Camarones',
          meanWeight: 'Peso medio (g)',
          biomass: 'Biomasa ({type})',
          feed: 'Alimento',
          feederBrand: 'Seleccionar alimentador',
          feedQuantity: 'Cantidad de alimento ({type})',
          summary: 'Resumen',
          switchLabel: 'Libras (lbs) / Kg',
        },
      },
      stocking: {
        deliveredTrackingCode: 'No. de Guía',
        genetics: 'Genética',
        larvaCost: 'Costo millar ($/millar larva)',
        maturation: 'Maduración/reproductoras',
        nauplius: 'Productoras de nauplio',
        laboratoryPl: 'Laboratorio PL',
        grid: {
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          startMeanWeight: 'Peso medio inicial (g)',
          targetMeanWeight: 'Peso medio objetivo (g)',
          startQuantity: 'Cantidad inicial',
          targetQuantity: 'Cantidad objetivo',
          targetEndDate: 'Duración del ciclo (días)',
          biomass: 'Biomasa (kg)',
          survivalRate: 'Tasa de supervivencia',
          summary: 'Resumen',
        },
      },
      harvest: {
        processorReference: 'Referencia del procesador',
        add: {
          harvestPond: 'Estanque de cosecha',
          number: 'No. Camarones',
          meanWeight: 'Peso medio (g)',
          biomass: 'Biomasa {type}',
          harvestNumber: 'Número de cosecha',
          harvestMw: 'Peso medio de cosecha (g)',
          harvestBm: 'Biomasa cosecha {type}',
          partialHarvest: 'Cosecha parcial',
          remainingNumber: 'Número restante',
          remainingMw: 'Peso medio restante (g)',
          remainingBm: 'Biomasa restante {type}',
          summary: 'Resumen',
          switchLabel: 'Libras (lbs) / Kg',
        },
        edit: {
          harvestPond: 'Estanque de cosecha',
          number: 'No. Camarones',
          meanWeight: 'Peso medio (g)',
          biomass: 'Biomasa {type}',
          harvestNumber: 'Número de cosecha',
          harvestMw: 'Peso medio de cosecha (g)',
          harvestBm: 'Biomasa cosecha {type}',
          partialHarvest: 'Cosecha parcial',
          remainingNumber: 'Número restante',
          remainingMw: 'Peso medio restante (g)',
          remainingBm: 'Biomasa restante {type}',
          summary: 'Resumen',
          switchLabel: 'Libras (lbs) / Kg',
        },
      },
      sampling: {
        add: {
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          zone: 'Granja',
          number: 'Número actual',
          meanWeight: 'Peso medio actual (g)',
          biomass: 'Biomasa actual (kg)',
          newMeanWeight: 'Peso medio nuevo (g)',
          survivalRate: 'Tasa de supervivencia',
          summary: 'Resumen',
        },
        edit: {
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          zone: 'Granja',
          number: 'Número actual',
          meanWeight: 'Peso medio actual (g)',
          biomass: 'Biomasa actual (kg)',
          newMeanWeight: 'Peso medio nuevo (g)',
          survivalRate: 'Tasa de supervivencia',
          summary: 'Resumen',
        },
      },
      transfer: {
        title: 'Estanque de transferencia',
        sourcePond: 'Estanque de Origen',
        destinationPonds: 'Destino de estanque',
        confirmTransfer: 'Confirm Transfer',
        partialTransferError:
          'El estanque de origen debe vaciarse para una transferencia completa. Puede seleccionar transferencia parcial arriba.',
        errorMessage: 'Values must be greater than 0',
        transferNumberError: 'Transfer cannot be greater than current number',
        selectDestinationPond: 'Seleccione estanque de destino',
        fields: {
          selectedDate: 'Fecha de registro seleccionada',
          sourcePond: 'Nombre del estanque',
          cycleName: 'Ciclo de origen',
          destinationPond: 'Estanque de destino',
          referenceCode: 'Delivered reference code',
          partialTransfer: 'Transferencia Parcial',
        },
        list: {
          name: 'Estanque',
          zone: 'Granja',
          status: 'Estado',
          days: 'No. Días',
          noShrimps: 'No. Camarones',
          biomass: 'Biomasa (kg)',
          meanWeight: 'Peso medio (g)',
        },
        listHeaders: {
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          meanWeight: 'Peso medio (g)',
          biomass: 'Biomasa (kg)',
          harvestDate: 'Fecha de cosecha',
          survivalRate: 'Tasa de supervivencia',
        },
        add: {
          source: {
            sourcePond: 'Estanque de origen',
            cycleName: 'Nombre del ciclo',
            currentNumberAdd: 'Cantidad actual (antes de la transferencia)',
            currentMw: 'Peso medio actual (g)',
            currentBm: 'Biomasa actual (kg)',
            newCycleName: 'Nuevo ciclo',
            transferNumber: 'Cantidad transferida',
            remainingQty: 'Número restante',
            remainingMw: 'Peso medio (g)',
            remainingBm: 'Biomasa restante (kg)',
          },
          destination: {
            currentQty: 'Cantidad actual (antes de la transferencia)',
            destinationPond: 'Estanque de destino',
            cycleName: 'Ciclo nuevo',
            transferQty: 'Cantidad transferida',
            transferMw: 'Peso medio (g)',
            transferBm: 'Biomasa (kg)',
            summary: 'Resumen',
          },
        },
        edit: {
          source: {
            sourcePond: 'Estanque de origen',
            partialTransfer: 'Transferencia Parcial',
            fullTransfer: 'Transferencia Completa',
            cycleName: 'Nombre del ciclo',
            currentQty: 'No. Camarones (antes de la transferencia)',
            currentMw: 'Peso medio (g) (antes de la transferencia)',
            currentBm: 'Biomasa (kg) (antes de la transferencia)',
            newCycleName: 'Nuevo ciclo',
            transferNumber: 'Cantidad transferida',
            remainingQty: 'Número restante',
            remainingMw: 'Peso medio (g)',
            remainingBm: 'Biomasa restante (kg)',
          },
          destination: {
            currentQty: 'Cantidad actual (antes de la transferencia)',
            destinationPond: 'Estanque de destino',
            cycleName: 'Ciclo nuevo',
            transferQty: 'Cantidad transferida',
            transferMw: 'Peso medio (g)',
            transferBm: 'Biomasa (kg)',
            summary: 'Resumen',
          },
        },
      },
      waterQuality: {
        registrationDate: 'Fecha de registro',
        destinationPonds: 'Estanques de destino',
        types: {
          1: 'Oxígeno Disuelto',
          2: 'Turbidez',
          3: 'Temperatura del Agua',
          4: 'Salinidad',
          5: 'pH',
        },
        add: {
          summary: 'Resumen',
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          zone: 'Granja',
          number: 'Número actual',
          meanWeight: 'Peso medio actual (g)',
          biomass: 'Biomasa actual (kg)',
          waterQualityType: 'Seleccionar Parámetro',
          value: 'Valor',
        },
        edit: {
          summary: 'Resumen',
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          zone: 'Granja',
          number: 'No. Camarones',
          meanWeight: 'Peso medio (g)',
          biomass: 'Biomasa (kg)',
          waterQualityType: 'Seleccionar Parámetro',
          value: 'Valor',
        },
        list: {
          name: 'Nombre',
          zone: 'Granja',
          status: 'Estado',
          days: 'No. Días',
        },
      },
      treatment: {
        Search: {
          NoResults: 'Sin resultados',
        },
        Buttons: {
          Confirm: 'Confirmar',
          ConfirmTreatment: 'Confirmar tratamiento',
        },
        add: {
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          zone: 'Granja',
          number: 'Número actual',
          meanWeight: 'Peso medio actual (g)',
          biomass: 'Biomasa actual (kg)',
          treatmentType: 'Seleccionar insumo',
          amount: 'Cantidad',
          summary: 'Resumen',
        },
        edit: {
          destinationPond: 'Estanque de destino',
          cycleName: 'Nombre del ciclo',
          zone: 'Granja',
          number: 'No. Camarones',
          meanWeight: 'Peso medio (g)',
          biomass: 'Biomasa (kg)',
          treatmentType: 'Seleccionar insumo',
          amount: 'Cantidad',
          summary: 'Resumen',
        },
      },
    },
    registrationLog: {
      title: 'Registro',
      notFoundMessage: 'No se han encontrado registros. Por favor intente con otra fecha o tipo de registro.',
      filters: {
        fromDate: 'Fecha Desde',
        toDate: 'Fecha Hasta',
        registrationType: 'Tipo de registro',
        showUserRegistrations: 'Mostrar sólo de usuario',
        hideEmptyDays: 'Ocultar días vacíos',
      },
      list: {
        registrationDate: 'Fecha de registro',
        logID: 'ID de registro',
        eventNumber: 'Número del evento',
        registrationType: 'Tipo de registro',
        email: 'Correo',
        dateCreated: 'Creado',
      },
      registrationTypes: {
        stocking: 'Siembra',
        transfer: 'Transferencia',
        harvest: 'Cosecha',
        feeding: 'Alimentación',
        treatment: 'Tratamiento',
        waterQualitySample: 'Muestra de calidad del agua',
        meanweightSample: 'Muestra de peso medio',
        mortality: 'Mortalidad',
        feederChange: 'Cambio de alimentador',
        aeratorChange: 'Cambio de aireador',
      },
    },
    farmSetup: {
      title: 'Conf. Granja',
      tooltip: {
        feeders: 'alimenatadores',
        aerators: 'aireadores',
        feedersCapacity: 'capacidad de alimento',
        aeratorsSupported: 'de biomasa soportada',
      },
      list: {
        name: 'Estanque',
        zone: 'Granja',
        active: 'Activo',
        days: 'No. Dias',
        noShrimps: 'No. Camarones',
        biomass: 'Biomasa ({type})',
        avgWeight: 'Peso medio (g)',
        feeders: 'Alimentadores',
        aerators: 'Aireadores',
        aeratorSupportedBiomass: 'Biomasa sop. Aireadores ({type})',
        feederSupportedBiomass: 'Biomasa sop. Alimentadores ({type})',
      },
      buttons: {
        previousDay: 'Día anterior',
        nextDay: 'Día próximo',
        manageAerators: 'Administrar Aireadores',
        manageFeeders: 'Administrar Alimentadores',
        done: 'Listo',
      },
      dialogs: {
        feeders: {
          feedersCapacity: 'de la demanda actual de alimento para el estanque actual',
          name: 'Nombre',
          brand: 'Marca',
          noUnits: 'No. de unidades',
          type: 'Tipo',
          storageCapacity: 'Cap. de almacenamiento kg',
          feedingCapacity: 'Cap. de alimentacion kg',
          currentCapacity: 'Biomasa actual del estaque: {biomass} kg',
          feeder: 'Alimentador',
          addFeeders: 'Agregar Alimentador a estanque',
          added: '(Agregado)',
          close: 'Cerrar',
        },
        aerators: {
          aeratorsSupported: 'de la actual biomasa soportada',
          name: 'Nombre',
          brand: 'Marca',
          noUnits: 'No. de unidades',
          type: 'Tipo',
          horsePower: 'Caballos de fuerza (HP) / unidad',
          supportedBiomass: 'Biomasa soportada / unidad',
          currentCapacity: 'Biomasa actual del estaque: {biomass} kg',
          aerator: 'Aireador',
          quantity: 'Cantidad',
          addAerators: 'Agregar Aireador a estanque',
          added: '(Agregado)',
          close: 'Cerrar',
        },
        registrationDate: 'Fecha de registro',
        addAeratorToPond: 'Agregar',
        addFeederToPond: 'Agregar',
      },
      filters: {
        showActive: 'Mostrar estanques activos',
        showInactive: 'Mostrar estanques inactivos',
        registrationDate: 'Fecha de registro',
        zone: 'Filtro por granja',
        selectAll: 'Seleccionar todo',
        pondType: 'Tipo de estanque',
        poundsOrKg: 'Libras (lbs) / kg',
        pondTypes: {
          Production: 'Producción',
          Raceway: 'Raceway',
          Nursery: 'Precria',
        },
      },
    },
  },
  selfService: {
    title: 'Autoservicio',
    feedCatalog: {
      title: 'Alimentos',
      createNewFeed: 'Agregar nuevo alimento',
      filters: {
        showActive: 'Mostrar alimentos activos',
        showInactive: 'Mostrar alimentos inactivos',
      },
      types: {
        extruded: 'Extruído',
        crumble: 'Quebrantado',
        pellet: 'Pelletizado',
        liquid: 'Líquido',
        soy: 'Soya',
        regular: 'Regular',
        functional: 'Funcional',
      },
      list: {
        feedBrandId: 'Id Marca de alimento',
        feedType: 'Tipo de alimento',
        feedSubType: 'Subtipo de alimento',
        name: 'Nombre',
        size: 'Tamaño',
        price: 'Precio',
        createdBy: 'Creado por',
        active: 'Activo',
        edit: 'Editar',
      },
      createFeedCatalog: {
        dialog: {
          title: 'Actualizar Alimento',
          button: 'Guardar',
          inputName: 'Nombre',
          selectFeedBrand: 'Seleccionar marca de aliemento',
          selectFeedType: 'Seleccionar tipo de alimento',
          selectFeedSubType: 'Seleccionar subtipo de alimento',
          inputSize: 'Tamaño',
          inputPrice: 'Precio',
          inactive: 'Inactivar alimento',
          inputCode: 'Código (opcional)',
          duplicatedCode: 'Ya existe un alimento con el código que ingresaste',
        },
      },
      editFeedCatalog: {
        dialog: {
          title: 'Actualizar Alimento',
          button: 'Guardar',
          inputName: 'Nombre',
          selectFeedBrand: 'Seleccionar marca de aliemento',
          selectFeedType: 'Seleccionar tipo de alimento',
          selectFeedSubType: 'Seleccionar subtipo de alimento',
          inputSize: 'Tamaño',
          inputPrice: 'Precio',
          inactive: 'Inactivar alimento',
          inputCode: 'Código (opcional)',
          duplicatedCode: 'Ya existe un alimento con el código que ingresaste',
        },
      },
    },
    treatmentCatalog: {
      title: 'Tratamientos',
      filters: {
        showActive: 'Mostrar tratamientos activos',
        showInactive: 'Mostrar tratamientos inactivos',
      },
      list: {
        code: 'Código',
        type: 'Tipo',
        brand: 'Marca',
        name: 'Nombre',
        price: 'Precio',
        treatmentCategory: 'ID cat. tratamiento',
        createdBy: 'Creado por',
        active: 'Activo',
        edit: 'Editar',
      },
      types: {
        liquid: 'Líquido',
        powder: 'Polvo',
        solid: 'Sólido',
        chemical: 'Químico',
        fertilizer: 'Fertilizante',
        probiotic: 'Probiótico',
        feedAddative: 'Aditivo Extrapellet',
        antibiotic: 'Antibiótico',
      },
      createTreatmentDialog: {
        dialog: {
          title: 'Agregar nuevo tratamiento',
          button: 'Guardar',
          code: 'Código',
          type: 'Seleccionar insumo',
          brand: 'Marca',
          name: 'Nombre',
          price: 'Precio',
          treatmentCategory: 'Categoría del tratamiento',
          inactive: 'Inactivar tratamiento',
          success: 'Tratamiento registrado',
          duplicatedCode: 'Ya existe un tratamiento con el código ingresado',
        },
      },
      editTreatmentCatalog: {
        dialog: {
          title: 'Actualizar tratamiento',
          button: 'Guardar',
          code: 'Código',
          type: 'Seleccionar insumo',
          brand: 'Marca',
          name: 'Nombre',
          price: 'Precio',
          treatmentCategory: 'Categoría del tratamiento',
          inactive: 'Inactivar tratamiento',
          duplicatedCode: 'Ya existe un tratamiento con el código ingresado',
        },
      },
    },
    aerators: {
      title: 'Aireadores',
      filters: {
        showActive: 'Mostrar aireadores activos',
        showInactive: 'Mostrar aireadores inactivos',
      },
      list: {
        name: 'Nombre',
        brand: 'Marca',
        type: 'Tipo',
        horsepower: 'Caballos de fuerza (HP)',
        biomassSupported: 'Biomasa Soportada (kg)',
        active: 'Activo',
        edit: 'Editar',
      },
      types: {
        electric: 'Eléctrico',
        diesel: 'Diésel',
        paddleWheel: 'Paletas',
        injection: 'Inyección',
        diffusion: 'Difusión',
      },
      createAerator: {
        btnTitle: 'Crear aireador',
        dialog: {
          title: 'Crear nuevo aireador',
          name: 'Nombre',
          brand: 'Marca (opcional)',
          type: 'Tipo',
          subType: 'Sub-tipo',
          horsepower: 'Caballos de fuerza (HP)',
          biomassSupported: 'Biomasa soportada',
          button: 'Guardar',
          switchLabel: 'Libras (lbs) / Kg',
        },
      },
      updateAerator: {
        dialog: {
          title: 'Actualizar aireador',
          name: 'Nombre',
          brand: 'Marca (opcional)',
          type: 'Tipo',
          subType: 'Sub-tipo',
          horsepower: 'Caballos de fuerza (HP)',
          biomassSupported: 'Biomasa soportada',
          inactive: 'Aireador Inactivo',
          button: 'Guardar',
          switchLabel: 'Libras (lbs) / Kg',
        },
      },
    },
    feeders: {
      title: 'Alimentadores',
      filters: {
        showActive: 'Mostrar alimenatadores activos',
        showInactive: 'Mostrar alimenatadores inactivos',
      },
      list: {
        name: 'Nombre',
        brand: 'Marca',
        storageCapacity: 'Cap. almacenamiento',
        supportedBiomass: 'Biom. alim. soportada',
        active: 'Activo',
        edit: 'Editar',
        kgFeeder: 'kg/alimentador',
      },
      createFeeder: {
        btnTitle: 'Crear alimentador',
        dialog: {
          title: 'Crear nuevo alimentador',
          name: 'Nombre',
          brand: 'Marca',
          storageCapacity: 'Cap. almacenamiento',
          supportedBiomass: 'Biomasa alimentada soportada',
          button: 'Guardar',
          endAdornment: '{unit}/alimentador',
          switchLabel: 'Libras (lbs) / Kg',
        },
      },
      updateFeeder: {
        dialog: {
          title: 'Actualizar alimentador',
          name: 'Nombre',
          brand: 'Marca',
          storageCapacity: 'Cap. almacenamiento',
          supportedBiomass: 'Biomasa alimentada soportada',
          inactive: 'Alimentador Inactivo',
          button: 'Guardar',
          endAdornment: '{unit}/alimentador',
          switchLabel: 'Libras (lbs) / Kg',
        },
      },
    },
  },
  form: {
    errors: 'Errores',
    rules: {
      required: 'Se requiere este campo',
      moreThanZero: 'El valor debe ser mayor a 0',
      minValue: 'El valor debe ser mayor a {min}',
      maxValue: 'El valor debe ser menor a {max}',
      between: 'El valor debe estar entre {lower} y {upper}',
      positive: 'No es posible tener un valor negativo',
      packaging: 'No hay valor desde empaque',
      multiple: 'La cantidad de producto debiera ser un múltiplo de {packaging}',
      largerThen: 'El valor es mayor a  {field}',
      duplication: 'Existe un producto igual en el pedido',
      errorMessage: 'El valor debe ser mayor a 0',
      invalidValue: 'Valor no válido',
    },
    buttons: {
      edit: 'Editar',
      nextFish: 'Próximo pez',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      downloadFile: 'Descargar archivo',
      chooseFile: 'Seleccionar archivo',
    },
    fileUpload: {
      heading: 'Exportar información',
      listRow: {
        fileName: 'Nombre del archivo',
        source: 'Fuente',
        destination: 'Destino',
        version: 'Versión',
        exportDate: 'Fecha de exportación',
        periodStart: 'Inicio del período',
        periodEnd: 'Fin del período',
        companies: 'Compañías',
      },
      options: {
        field: 'Campo',
        value: 'Valor',
        siteName: 'Nombre del Centro',
        lastDate: 'Última fecha de registro',
        latitude: 'Latitud',
        longitude: 'Longitud',
      },
    },
  },
  snackbar: {
    success: {
      default: 'Éxito',
      calc: 'Ejecute la calibración',
      scenarioRunStarted: 'Scenario run started.',
      scenarioResultsReady: 'Scenario results are ready.',
      viewResults: 'View results',
    },
    errors: {
      default: 'Ha ocurrido un error',
    },
    warning: {
      default: 'Advertencia',
    },
  },
  dialog: {
    delete: {
      title: '¿Está usted seguro?',
    },
  },
  benchmarkAnalytics: {
    growth: 'Crecimiento',
    placeholderOne: 'Marcador 1',
    placeholderTwo: 'Marcador 2',
    growthPage: {
      filters: {
        day: 'Día',
        week: 'Semana',
        month: 'Mes',
        quarter: 'Trimestre',
        fullCycle: 'Ciclo completo',
        finalStage: 'Etapa final',
        fromDate: 'Fecha desde',
        toDate: 'Fecha hasta',
        clear: 'Limpiar',
        reset: 'Restablecer',
        addFarm: 'Añadir una granja para comparar',
        farmsSelected: '{count} de {total} seleccionadas',
        farmsAll: 'Todas ({total})',
        selectAll: 'Seleccionar todas',
        groupingLabel: 'Agrupación temporal',
        variantLabel: 'Variante de crecimiento',
      },
      caption: 'Mercado: {market} puntos diarios | Empresa: {company}',
      kpi: {
        periods: 'Periodos',
        periodsCaption: '{count} periodos de {grouping} en el rango',
        companyAvg: 'Crecimiento promedio de la empresa (g/día)',
        marketAvg: 'Crecimiento promedio del mercado {market} (g/día)',
        weightedOverall: 'promedio ponderado general',
        periodsMatched: '{count} periodos coincidentes',
        overallDelta: 'Δ general vs mercado',
        aboveMarket: 'por encima del mercado',
        belowMarket: 'por debajo del mercado',
        equalMarket: 'igual al mercado',
      },
      chart: {
        title: 'Crecimiento ({variant}) vs mercado',
        yAxis: 'Tasa de crecimiento (g/día)',
        xAxis: 'Periodo',
        thisCompany: 'Esta empresa',
        marketAvg: 'Promedio mercado {market}',
        noData: '(sin datos)',
        allHidden: 'Todas las series están ocultas.',
        empty: 'No hay datos para esta selección.',
        error: 'No se pudieron cargar los datos de crecimiento.',
        retry: 'Reintentar',
      },
      table: {
        title: 'Benchmark de crecimiento — {variant}',
        period: 'Periodo',
        company: 'Crecimiento de la empresa (g/día)',
        market: 'Promedio del mercado (g/día)',
        farmGrowth: 'Crecimiento de {farm}',
        delta: 'Δ vs mercado',
        periodsFooter: '{count} periodos',
        scrollLeft: 'Desplazar una columna a la izquierda',
        scrollRight: 'Desplazar una columna a la derecha',
      },
      unit: {
        gPerDay: 'g/día',
      },
    },
  },
  sidebar: {
    overview: 'Vista General',
    deliveryBoard: 'Panel de Entrega',
    orderFeed: 'Solicitar Alimento',
    fishCheck: 'Registro de Campo',
    planningPrognosis: 'Planificación y Pronóstico',
    reports: 'Reportes',
    seaCloudFileUpload: 'Cargar Archivo SeaCloud',
    bluViuNutrition: 'bluViu Nutrition',
    feedManagement: 'Administrar Alimentos',
    siteSettings: 'Ajustes de Sitio',
    profilesStrategies: 'Perfiles y Estrategias',
    fileSharing: 'Archivos',
    settings: 'Configuraciones',
    logout: 'Cierre de Sesión',
    shrimpDataUpload: 'Cargar datos camarón',

    productionSystems: 'Sistemas de Producción',
    benchmarkAnalytics: 'Benchmark Analytics',
    selfService: 'Autoservicio',

    playground: 'Playground',
  },
  footer: {
    copyright: 'Copyright © Cargill, Incorporated. Reservados todos los derechos.',
    copyrightUk: 'Copyright © 2022 Cargill, Incorporated. Todos los Derechos reservados.',
    ukAddress: 'EWOS Limited. Registered Office: 7th Floor, 33 King William Street, London, EC4R 9AT',
    ukRegister: ' Registered in England and Wales, Company No: 01635854',
  },
  MobileAppBanner: {
    title: 'Obtén la app de BluViu',
    description: 'Disfruta de una mejor experiencia en tu teléfono con nuestra app móvil.',
  },
};
